import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from "react";
import styled from "styled-components";
import { Tab } from "../../Reusablecomponents/Tab";
import {
  Badge,
  Button,
  Col,
  Row,
  Avatar,
  Checkbox,
  Space,
  Popover,
  Menu,
  Dropdown,
  Tooltip,
  Form,
  Spin,
  message,
  Select,
  InputNumber,
  Input,
  Collapse,
  Upload,
  Card,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import {
  ButtonFilled,
  ButtonOutlined,
  Buttontransparent,
} from "../../Reusablecomponents/UIButtons";
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import { ReactComponent as CopyIcon } from "../../assets/images/Vector.svg";
import { ReactComponent as EditIcon } from "../../assets/images/Editicon.svg";
import { ReactComponent as DeleteIcon } from "../../assets/images/delete-icon.svg";
import { ReactComponent as Deleteunassigned } from "../../assets/images/deleteunassigned.svg";
import { ReactComponent as BulkDelete } from "../../assets/images/BulkDelete.svg";
import { ReactComponent as GeoDelete } from "../../assets/images/GeoDelete.svg";
import FilterIcon from "../../assets/images/Filter-Icon.svg";
import SortIcon from "../../assets/images/sort-svgrepo-com.svg";
import ImportIcon from "../../assets/images/download1.svg";
import ExportIcon from "../../assets/images/export-svgrepo-com (1).svg";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../Reusablecomponents/ReusableDrawer";
import UIModal from "../../Reusablecomponents/UIModal";
import Consignordetails1 from "./consigndetails";
import { CALL_API } from "../../Common/api";
import {
  chargetype,
  PanTripTypeEnum,
  TripTypeEnum,
  DispatchType,
  FinishType,
  shipmentType,
  finishedtype,
} from "../../Common/constant";
import { useSelector } from "react-redux";
import moment from "moment";
import {
  AIConsignmentDeliveryEvents,
  AIConsignmentCollectionEvents,
  AIConsignmentCombinedEvents,
} from "../../Common/constant";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import LocationPicker from "../../Reusablecomponents/LocationPicker/LocationPicker";
import ReusablePagination from "../../Reusablecomponents/ReusablePagination";
import axios from "axios";
import { CSVLink } from "react-csv";
import { useLocation, useParams } from "react-router-dom";
import ImportFileModal from "./importFileModal";

const { RangePicker } = DatePicker;

const { Panel } = Collapse;
const { Option } = Select;

const MAPBOX_TOKEN =
  "pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow";

export const WrapperBox = styled.div`
  /* .ant-select {
    width: 100% !important;
  } */
  .selectdropdown_responsive {
    width: 100% !important;
  }
  .selectdropdown_responsive .custom-dropdown .ant-select-item-option-active {
    background-color: #f6ffed !important;
  }
  .selectdropdown_responsive .custom-dropdown .ant-select-item-option-selected {
    background-color: rgb(232, 255, 236) !important;
  }
  .selectdropdown_responsive .ant-select-selector {
    background-color: rgb(232, 255, 236) !important;
    border-radius: 8px !important;
    padding: 8px 12px !important;
  }
  .ant-select-arrow {
    color: #333 !important;
  }

  background-color: white;
  height: 60pz;
  padding: 9px 7px 3px 7px;
  border-radius: 8px;
  .consingment_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #5f6d8c;
    font-weight: 400;
    font-size: 16px;
    line-height: 19.36px;
  }
  .FilterIcon {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    // border-radius:50%;
    background-color: #ebf7ed !important;
    margin-left: 10px;
  }

  @media (max-width: 320px) {
    /* .consingment_container {
      display: flex;
      align-items: center;
      flex-direction: column;
      color: #5f6d8c;
    } */
    /* .consingment_container_two {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 20px 0px 08px 0px;
    } */
    .ant-tabs-nav .ant-tabs-nav-list {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 20px 0px 08px 0px;
    }
  }
  .consingment_container_two {
    display: flex;
    align-items: center;
  }
  p {
    margin-bottom: 0px;
    line-height: 0px;
    font-size: 16px;
    font-weight: 400;
  }
  .Create_btn {
    width: 150;
    height: 38;
    gap: 8px;
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: rgb(44, 150, 61) !important;
    color: white !important;
  }
  .bulk_btn {
    width: 150;
    height: 38;
    gap: 8px;
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: #e8ffec !important;
    color: #2c963d !important;
  }
  .ant-input {
    border-radius: 26px !important;
  }
  .Creating_Consignment {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px 0px 10px 0px;
    border-bottom: 1px solid rgb(231 231, 237);
    padding: 8px 7px 15px 8px;
  }
  .ant-badge.ant-badge-status .ant-badge-status-dot {
    width: 12px;
    height: 12px;
  }
  .badg {
    padding: 6px;
  }

  .modal_container_forfiltermenu {
    display: flex;
    justify-content: space-between;
    margin: 7px 14px 7px 0px;
  }
  .flilter_five {
    font-weight: 500;
    font-size: 20px;
    line-height: 24.2px;
  }
  .Custom {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .container_for_assigned_unassigned {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 15px;
  }
  .consingment_container {
    /* margin: 16px 0px 10px 0px; */
  }
  /* @media (min-width: 320px) and (max-width: 426px) {
    .container_for_assigned_unassigned {
      display: block;
    }
    .consingment_container_two {
      display: block;
    }
    .consingment_container {
      margin-top: 25px !important;
    }
    .responsive_containerone {
      display: flex;
      gap: 09px;
      flex-wrap: wrap;
      align-items: center;
      margin-top: 15px !important;
      justify-content:space-between;
    }
    .consingment_container {
      margin: 3px !important;
    }
    .datsource_length {
      margin-top: 2px !important;
    }
  } */

  @media (max-width: 321px) {
    .selectdropdown_responsive {
      width: 100% !important;
    }
    .container_for_assigned_unassigned {
      display: block;
    }
    .consingment_container_two {
      display: block;
    }
    .consingment_container {
      margin-top: 25px !important;
    }
    .responsive_containerone {
      display: flex;
      gap: 09px;
      flex-wrap: wrap;
      align-items: center;
      margin-top: 15px !important;
    }
    .consingment_container {
      margin: 3px !important;
    }
    .datsource_length {
      margin-top: 2px !important;
    }
  }
  @media (min-width: 322px) and (max-width: 376px) {
    .selectdropdown_responsive {
      width: 100% !important;
    }
    .container_for_assigned_unassigned {
      display: block;
    }
    .consingment_container_two {
      display: block;
    }
    .consingment_container {
      margin-top: 25px !important;
    }
    .responsive_containerone {
      display: flex;
      gap: 09px;
      flex-wrap: wrap;
      align-items: center;
      margin-top: 15px !important;
      justify-content: space-between;
    }
    .consingment_container {
      margin: 3px !important;
    }
    .datsource_length {
      margin-top: 2px !important;
    }
  }
  @media (min-width: 377px) and (max-width: 480px) {
    .mobile_section .selectdropdown_responsive {
      width: 100% !important;
    }
    .container_for_assigned_unassigned {
      display: block;
    }
    .consingment_container_two {
      display: block;
    }
    .consingment_container {
      margin-top: 25px !important;
    }
    .responsive_containerone {
      display: flex;
      gap: 20px;
      flex-wrap: wrap;
      align-items: center;
      margin-top: 15px !important;
      /* justify-content: space-between; */
    }
    .consingment_container {
      margin: 3px !important;
    }
    .datsource_length {
      margin-top: 2px !important;
    }
  }

  .checkbox_group_container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .checkbox_group_container .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #28a745; /* green */
    border-color: #28a745;
  }

  .checkbox_group_container .ant-checkbox:hover .ant-checkbox-inner {
    border-color: #28a745;
  }

  .checkbox_group_container
    .ant-checkbox-indeterminate
    .ant-checkbox-inner::after {
    background-color: #28a745;
  }

  .ant-collapse,
  .ant-collapse-item,
  .ant-collapse-content,
  .ant-collapse-content > .ant-collapse-content-box {
    background-color: #ebf7ed !important;
    border: none !important;
    border-radius: 8px !important;
  }
  .ant-collapse > .ant-collapse-item {
    border-bottom: none !important;
  }
  .ant-collapse .ant-collapse-header {
    border: none !important;
    box-shadow: none !important;
  }
  .trip-table .ant-table,
  .trip-table .ant-table-container,
  .trip-table .ant-table-content,
  .trip-table .ant-table-thead > tr > th,
  .trip-table .ant-table-tbody > tr > td {
    background-color: #ebf7ed !important;
    border: none !important;
  }
  .trip-table .ant-table-thead > tr > th,
  .trip-table .ant-table-tbody > tr > td {
    border-bottom: none !important;
  }

  @media screen and (min-width: 481px) and (max-width: 768px) {
    div[tabindex="0"] {
      width: 100% !important;
      height: 0vh !important;
    }
    .ant-tabs .ant-tabs-tab {
      display: inline !important;
    }
  }
`;

const TableStyle = styled.div`
  width: 100% !important;
  .footer-btn {
    border-radius: 10px;
    font-size: 11px;
    font-weight: 600;
    padding: 8px 10px !important;
    margin: 2px !important;
    border: none !important;
    /* width: 130px !important; */
    border-radius: 60px;
  }
  .footer_assigntrip {
    background-color: rgb(232, 255, 236) !important;
    color: #2c963d !important;
    border-radius: 10px;
  }

  @media screen and (min-width: 481px) and (max-width: 2560px) {
    width: 100% !important;
    .footer-btn {
      border-radius: 10px;
      font-size: 20px;
      font-weight: 500;
      padding: 8px 10px !important;
      margin: 2px !important;
      border: none !important;
      /* width: 130px !important; */
      border-radius: 60px;
    }
    .footer_assigntrip {
      background-color: rgb(232, 255, 236) !important;
      color: #2c963d !important;
      border-radius: 20px;
      width: 145px;
    }
  }

  .bottom-action-bar {
    position: fixed;
    bottom: 0;
    left: 250px; /* Adjust if your sidebar is a different width */
    width: calc(100% - 200px); /* Adjust if needed */
    background-color: white;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding: 12px 12px;
    z-index: 1000; /* Make sure it's above other content */
  }
  .bottom-action-bar button {
    padding: 8px 16px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    margin-left: 10px;
  }
  .bottom-action-bar button:nth-child(1) {
    width: 150px;
    height: 38px;
    gap: 8px;
    font-weight: 500;
    font-size: 16px;
    color: red;
    background-color: #ffffff;
  }
  .bottom-action-bar button:nth-child(2) {
    width: 150px;
    height: 38px;
    gap: 8px;
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: #e8ffec !important;
    color: #2c963d !important;
  }
  .bottom-action-bar button:nth-child(3) {
    width: 150px;
    height: 38px;
    gap: 8px;
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: rgb(44, 150, 61) !important;
    color: white !important;
    margin-right: 120px;
  }
  .container_six {
    display: flex !important;
    width: 100% !important;
    justify-content: space-between;
    align-items: center;
  }
`;

const ConsignmentAI = () => {
  const latlongList = useSelector((state) => state?.authTracking?.latlongList);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const AIVehicleLists = useSelector(
    (state) => state?.authTracking?.AIVehicleLists,
  );
  const fenceList = useSelector((state) => state?.authTracking?.fenceList);
  const driverWithVehicle = useSelector(
    (state) => state?.authTracking?.driverWithVehicle,
  );
  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const driverList = useSelector((state) => state?.authTracking?.driverList);
  const countryList = useSelector((state) => state?.authTracking?.countryList);
  const location = useLocation();
  const { consignmentRecord } = location.state || {};
  //navigation on home page function
  const { stage, shipmentTypes } = location.state || {};
  useEffect(() => {
    if (stage || shipmentTypes) {
      if (stage) handleFilterSelectChange(stage, "event");
      if (shipmentTypes) handleFilterSelectChange(shipmentTypes, "shipment");
      // When navigated from home page, force duration to empty
      filterform.setFieldValue("duration", "");
      filterform.setFieldValue("daterange", [null, null]);
      setFilterData((prev) => ({
        ...prev,
        duration: "",
        daterange: [null, null],
      }));
    }
  }, [stage, shipmentTypes]);

  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filterCount, setFilterCount] = useState(0);
  const [filterData, setFilterData] = useState({
    duration: "current_month",
    daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
  });
  const [importOpen, setImportOpen] = useState(false);
  const tripType = [
    {
      label: "Local",
      value: 1,
    },
    { label: userInfo?.MCID === 72 ? "Transit" : "Safari", value: 2 },
  ];

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };
  const [form] = Form.useForm();
  const [filterform] = Form.useForm();
  const [tripform] = Form.useForm();
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  // navigate home page create consinment tab
  useEffect(() => {
    if (location.state?.tab === "CreateSingleConsignment") {
      setDrawerOpen(true);
      setFormType("addEdit"); // this will trigger single consignment form
    }
  }, [location.state]);

  useEffect(() => {
    const duration = form.getFieldValue("duration");

    if (duration === "last_month") {
      form.setFieldValue("daterange", [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ]);
      setFilterData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [
          dayjs().subtract(1, "month").startOf("month"),
          dayjs().subtract(1, "month").endOf("month"),
        ],
      }));
    } else if (duration === "current_month") {
      form.setFieldValue("daterange", [
        dayjs().startOf("month"),
        dayjs().endOf("month"),
      ]);
      setFilterData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [dayjs().startOf("month"), dayjs().endOf("month")],
      }));
    } else if (duration === "current_year") {
      form.setFieldValue("daterange", [
        dayjs().startOf("year"),
        dayjs().endOf("year"),
      ]);
      setFilterData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [dayjs().startOf("year"), dayjs().endOf("year")],
      }));
    } else if (duration === "today") {
      form.setFieldValue("daterange", [dayjs(), dayjs()]);
      setFilterData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [dayjs(), dayjs()],
      }));
    } else if (duration === "---") {
      form.setFieldValue("daterange", [null, null]);
      setFilterData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [null, null],
      }));
    }

    // else {
    //   const today = dayjs();
    //   const sameDayLastMonth = today.subtract(1, 'month');
    //   form.setFieldValue("daterange", [ today, sameDayLastMonth]);
    //   setFilterData((PrevValue) => ({
    //     ...PrevValue,
    //     ["daterange"]: [
    //       today , sameDayLastMonth
    //     ],
    //   }));
    // }
  }, [form.getFieldValue("duration")]);

  useEffect(() => {
    // Set default filter only if not navigating from Home
    if (!location.state?.stage && !location.state?.shipmentTypes) {
      filterform.setFieldsValue({
        duration: "current_month",
        daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
      });
      setFilterData({
        duration: "current_month",
        daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
      });
    }
  }, []);

  //event type functionality

  const [EventType, setEventType] = useState(AIConsignmentCollectionEvents);
  const handleShipmentChange = (shipment) => {
    if (shipment === 1) {
      setEventType(AIConsignmentDeliveryEvents);
    } else if (shipment === 2) {
      setEventType(AIConsignmentCollectionEvents);
    } else {
      setEventType([AIConsignmentCombinedEvents]); // or default options
    }
  };

  const tabItems = [
    {
      key: "label1",
      label: "Assigned",
    },
    {
      key: "label2",
      label: "Unassigned",
    },
  ];

  const [visibleExport, setVisibleExport] = useState(false);
  const [visibleImport, setVisibleImport] = useState(false);
  const [visibleSort, setVisibleSort] = useState(false);
  const [assignedConsignments, setAssignedConsignments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [consignmentDetails, setConsignmentDetails] = useState({});
  const [locationModal, setLocationModal] = useState(false);
  const [isCreateTrip, setIsCreateTrip] = useState(false);
  const [isConformationModal, setIsConformationModal] = useState(false);
  const [newLoading, setNewLoading] = useState(false);
  const [customFields, setCustomFields] = useState([]);
  const [selectedCustomColumns, setSelectedCustomColumns] = useState([]);
  const [customDataLoaded, setCustomDataLoaded] = useState(false);
  const [formType, setFormType] = useState("addEdit"); // 'addEdit' or 'bulkCreate'
  //custome data Get All function
  const [AllCustomeData, SetAllCustomeData] = useState([]);
  const [tripCustomFields, setTripCustomFields] = useState([]);
  const [modaldrawyer, setModaldrawer] = useState(false);
  const reftab = formType === "addEdit" ? "AICONSIGN" : "AIBulkcreate";
  const [newtimeandvalue, setnewtimeandvalue] = useState(null);
  const [isDeviceDisabled, setIsDeviceDisabled] = useState(true);

  // const generateTimeandsecond = (date = new Date()) => {
  //  const d = new Date(
  //     date.toLocaleString("en-US", { timeZone: "Asia/Kolkata"  })
  //   );
  //   const pad = (n) => String(n).padStart(2, "0");
  //   const Y = d.getFullYear();
  //   const M = pad(d.getMonth() + 1);
  //   const D = pad(d.getDate());
  //   const h = pad(d.getHours());
  //   const m = pad(d.getMinutes());
  //   const s = pad(d.getSeconds());
  //   return `${Y}-${M}-${D} ${h}:${m}:${s}`;
  // };
  function generateKenyaTime(date = new Date()) {
    const options = {
      timeZone: "Africa/Nairobi",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour12: false,
    };
    const formatter = new Intl.DateTimeFormat("en-GB", options);
    const parts = formatter.formatToParts(date);

    const y = parts.find((p) => p.type === "year").value;
    const m = parts.find((p) => p.type === "month").value;
    const d = parts.find((p) => p.type === "day").value;
    const h = parts.find((p) => p.type === "hour").value;
    const min = parts.find((p) => p.type === "minute").value;
    const s = parts.find((p) => p.type === "second").value;

    return `${y}-${m}-${d} ${h}:${min}:${s}`;
  }

  let timeNow = generateKenyaTime();
  let afterOneHour = generateKenyaTime(new Date(Date.now() + 60 * 60 * 1000));

  const [formData, setFormData] = useState({
    company: userInfo?.MCID === 59 ? "" : userInfo.COMPNAME,
    ConsignorName: "",
    consignor:
      userInfo?.MCID === 71
        ? 14045
        : userInfo?.MCID === 46
          ? 32921
          : userInfo?.MCID === 55
            ? 1
            : "",
    transporter:
      userInfo?.MCID === 71
        ? 14046
        : userInfo?.MCID === 46
          ? 32922
          : userInfo?.MCID === 55
            ? 2
            : userInfo?.MCID === 3
              ? 91
              : userInfo?.MCID === 78 || userInfo?.MCID === 72
                ? 2
                : "", // Auto-select for MCID 71
    consignee: [{}],
    fence: [{}],
    chargetype:
      userInfo?.MCID === 46 || userInfo?.MCID === 55
        ? 6
        : userInfo?.MCID === 3 || userInfo?.MCID === 72 || userInfo?.MCID === 78
          ? 3
          : "",
    priority: userInfo?.MCID === 55 ? 1 : "",
    noofdeliverables: "",
    dimension: "",
    gross: "",
    switch: false,
    plocation: "",
    pdate: userInfo?.MCID === 55 ? dayjs(timeNow) : "",
    dlocation: "",
    ddate: userInfo?.MCID === 55 ? dayjs(afterOneHour) : "",
    pnotes: "",
    dnotes: "",
    remark: "",
    linkdossier: "",
    orderno: "",
    referenceno: "",
    containerno: "",
    zone: "",
    shipmentType:
      userInfo?.MCID === 71 ||
      userInfo?.MCID === 46 ||
      userInfo?.MCID === 55 ||
      userInfo?.MCID === 78
        ? 1
        : userInfo?.MCID === 3
          ? 2
          : "",
    dispatchtype:
      userInfo?.MCID === 46 ||
      userInfo?.MCID === 55 ||
      userInfo?.MCID === 3 ||
      userInfo?.MCID === 78 ||
      userInfo?.MCID === 72
        ? "0"
        : "",
    tripType:
      userInfo?.MCID === 55 || userInfo?.MCID === 78
        ? 1
        : userInfo?.MCID === 3
          ? 2
          : "",
    tripallowance: "",
    finishtype:
      userInfo?.MCID === 71 || userInfo?.MCID === 46 || userInfo?.MCID === 55
        ? 5
        : userInfo?.MCID === 3 || userInfo?.MCID === 72
          ? 0
          : userInfo?.MCID === 78
            ? 1
            : "",
    fuelQuantity: "",
    vehicle: "",
    device: "",
    route: "",
    deliveryNo: "",
    ReferenceNo: "",
    ContainerNo: "",
    dlocationname: {},
    plocationname: {},
  });

  const [resetCount, setResetCount] = useState(0);
  const handleCreateAnotherTrip = () => {
    setFormData((prev) => ({
      ...prev,
      pdate: "",
      ddate: "",
    }));
    setResetCount((prev) => prev + 1);
  };
  useEffect(() => {
    if (formType === "bulkCreate" || formType === "addEdit") {
      setFormData((prev) => ({
        ...prev,
        pdate: dayjs(timeNow),
        ddate: dayjs(afterOneHour),
      }));
    }
  }, [formType, resetCount]);

  useEffect(() => {
    setnewtimeandvalue(timeNow);
    generateKenyaTime();
  }, []);

  useEffect(() => {
    form.setFieldsValue(formData);
  }, [formType, form]);

  const GetAllCustomeData = async (reftab) => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "GET",
        `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=${reftab}`,
      );

      SetAllCustomeData(data);
      setCustomDataLoaded(true);
    } catch (error) {
      console.error("Error fetching custom data", error);
    } finally {
      setLoading(false);
    }
  };
  filterform.getFieldValue("daterange");

  const getAssignedConsignments = async () => {
    setLoading(true);
    try {
      const daterange = filterform?.getFieldValue("daterange");
      const dateFrom =
        // daterange && dayjs(daterange[0]).isValid()
        //   ? dayjs(daterange[0]).format("YYYY-MM-DD")
        //   : "";
        (activeTab === "label2" || activeTab === "label1") &&
        location.state?.dates
          ? location.state?.dates
          : daterange && dayjs(daterange[0]).isValid()
            ? dayjs(daterange[0]).format("YYYY-MM-DD")
            : "" || location.state.dates
              ? dayjs(location.state.dates).format("YYYY-MM-DD")
              : "";
      const dateTo =
        daterange && dayjs(daterange[1]).isValid()
          ? dayjs(daterange[1]).format("YYYY-MM-DD")
          : "" || location.state.dates
            ? dayjs(location.state.dates).format("YYYY-MM-DD")
            : "";
      const { data, total } = await CALL_API("POST", "ai/consignments/getAll", {
        mcId: userInfo?.MCID,
        custName: filterData?.consignor || "",
        recName: filterData?.consignee || "",
        regNo: filterData?.vehicle || "",
        status: activeTab === "label2" ? "1" : "2",
        priority: filterData?.priority || 1,
        code: filterData?.code || "",
        driverName: filterData?.driver || "",
        dateFrom: dateFrom,
        dateTo: dateTo,
        town: filterData?.town || 0,
        EvType: filterData?.event || 0,
        ShipmentType: filterData?.shipment || 0,
        shipper: filterData?.transporter || "",
        ContainerNo: filterData?.containerno || "",
        ReferenceNo: filterData?.referenceno || "",
        page: currentPage,
        pageSize: pageSize,
        sortColumns: sortColumns,
      });
      const newData1 = data?.data?.map((entityItem) => {
        const enrichedItem = { ...entityItem };

        // Attach custom field values by matching REFID to ConsignId
        const matchedFields =
          (Array.isArray(AllCustomeData) ? AllCustomeData : []).filter(
            (field) => Number(field.REFID) === Number(entityItem.ConsignId),
          ) || [];

        matchedFields.forEach((field) => {
          enrichedItem[field.CFID] = field.VALUE;
        });

        return enrichedItem;
      });

      setAssignedConsignments(newData1 || []);
      setTotal(data?.total || 0);
    } catch (error) {
      // Optionally handle error
      console.error("Error in getAssignedConsignments", error);
    } finally {
      setLoading(false); // Always set loading to false at the end
    }
  };

  // Ensure assigned consignments are fetched only after
  // custom data and custom column configuration are ready
  useEffect(() => {
    if (
      customDataLoaded &&
      Array.isArray(customFields) &&
      customFields.length > 0 &&
      Array.isArray(selectedCustomColumns) &&
      selectedCustomColumns.length > 0
    ) {
      getAssignedConsignments();
    }
  }, [customDataLoaded, customFields, selectedCustomColumns]);

  const TRIP_REFTAB = "Trip"; // or whatever your backend expects

  const loadTripCustomFields = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: TRIP_REFTAB,
        RefId: 0,
        Active: 1,
        McId: userInfo?.MCID,
      });
      setTripCustomFields(data);
    } catch (error) {
      setTripCustomFields([]);
      message.error("Failed to load trip custom fields.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (isCreateTrip) {
      loadTripCustomFields();
    }
  }, [isCreateTrip]);
  const [CreateTripCustomeData, setCreateTripCustomeData] = useState([]);

  const CustomeTripDataCreate = async (TRIPID, values) => {
    try {
      const customDataList = tripCustomFields
        .map((field) => {
          if (!field?.FIELDNAME) return null;

          const fieldName = field.FIELDNAME.replace(/\s+/g, "_").toLowerCase();
          const value = values?.[fieldName];

          if (value !== undefined && value !== "") {
            return {
              CfId: field.CFID,
              RefId: TRIPID,
              Value: value,
            };
          }

          return null;
        })
        .filter(Boolean);

      if (customDataList.length === 0) {
        return;
      }

      const { data } = await CALL_API("POST", "mastertable/CreateCFID", {
        customDataList,
      });

      setCreateTripCustomeData(data);
    } catch (error) {
      console.error("Custom field creation error:", error);
      setCreateTripCustomeData([]);
    }
  };
  const prepareCSV = async () => {
    try {
      setCSVLoader(true);
      const daterange = filterform?.getFieldValue("daterange");
      const dateFrom =
        daterange && dayjs(daterange[0]).isValid()
          ? dayjs(daterange[0]).format("YYYY-MM-DD")
          : "";
      const dateTo =
        daterange && dayjs(daterange[1]).isValid()
          ? dayjs(daterange[1]).format("YYYY-MM-DD")
          : "";
      const { data } = await CALL_API("POST", "ai/consignments/getAll", {
        mcId: userInfo?.MCID,
        custName: filterData?.consignor || "",
        FID: filterData?.fence || "",
        regNo: filterData?.vehicle || "",
        status: activeTab === "label2" ? "1" : "2",
        priority: filterData?.priority || 1,
        code: filterData?.code || "",
        driverName: filterData?.driver || "",
        dateFrom: dateFrom,
        dateTo: dateTo,
        town: filterData?.town || 0,
        shipper: filterData?.transporter || "",
        ContainerNo: filterData?.containerno || "",
        ReferenceNo: filterData?.referenceno || "",
        page: 1,
        pageSize: total,
      });

      const consignmentData = data?.data || [];
      const customFieldMap = {};
      (Array.isArray(customFields) ? customFields : []).forEach((cf) => {
        if (cf.CFID) {
          customFieldMap[cf.CFID] = cf.FIELDNAME || cf.FIELDCODE;
        }
      });
      const enrichedData = consignmentData.map((item) => {
        const matchedFields =
          (Array.isArray(AllCustomeData) ? AllCustomeData : []).filter(
            (f) => f.REFID === item.ConsignId,
          ) || [];

        const customFieldValues = {};

        // Ensure every custom field exists
        (Array.isArray(customFields) ? customFields : []).forEach((cf) => {
          const fieldName = customFieldMap[cf.CFID] || `Custom_${cf.CFID}`;

          const matched = matchedFields.find((f) => f.CFID === cf.CFID);

          customFieldValues[fieldName] = matched?.VALUE || "-";
        });

        // Merge base and custom data for export
        return {
          Date: item.cron
            ? dayjs(item.cron).format("DD-MM-YYYY HH:mm:ss")
            : "-",
          "Consign Code": item.Code || "-",
          Priority: item.Priority === 1 ? "High" : "Normal",
          "Vehicle/Driver": `${item.VehRegNo || "-"}/${item.DriverName || "-"}`,
          Event:
            (item.ShipmentType === 1
              ? AIConsignmentDeliveryEvents
              : AIConsignmentCollectionEvents
            ).find((ev) => ev.value === item.LastModify)?.name ||
            (activeTab === "label2" ? "Unassigned" : "Assigned"),
          Consignor: item.CustName || "-",
          Consignee: item.FNAME || "-",
          Transporter: item?.SupName || "-",
          Location: locationCache[`${item.EndLat},${item.EndLng}`] || "-",
          "Reference No": item?.ReferenceNo,
          "Container No": item?.ContainerNo,
          ...customFieldValues,
        };
      });

      // Export if data exists
      if (enrichedData.length > 0) {
        setCSVList(enrichedData);
        setTimeout(() => csvLinkEl.current.link.click(), 500);
      } else {
        message.error("No data available to download.");
      }

      setCSVLoader(false);
    } catch (error) {
      setCSVLoader(false);
      console.error("[prepareCSV] error -->", error);
    }
  };
  //Custome Field api calling Function

  const loadCustomFields = async (reftab) => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: reftab,
        RefId: 0,
        Active: 1,
        McId: userInfo?.MCID,
      });
      setCustomFields(data);
    } catch (error) {
      setCustomFields();
      console.error("Error fetching custom fields:", error);
    } finally {
      setLoading(false);
    }
  };
  const [CreateCustomeData, setCreateCustomeData] = useState([]);

  const CustomeDataCreate = async (reftab, ConsignId, values) => {
    try {
      const customDataList = customFields
        .map((field) => {
          if (!field?.FIELDNAME) return null;

          const fieldName = field.FIELDNAME.replace(/\s+/g, "_").toLowerCase();
          const value = values?.[fieldName];

          if (value !== undefined && value !== "") {
            return {
              CfId: field.CFID,
              RefId: ConsignId,
              Value: value,
            };
          }

          return null;
        })
        .filter(Boolean);
      if (customDataList.length === 0) {
        return;
      }

      const { data } = await CALL_API("POST", "mastertable/CreateCFID", {
        customDataList,
      });

      setCreateCustomeData(data);
    } catch (error) {
      console.error("Custom field creation error:", error);
      setCreateCustomeData([]);
    }
  };

  //Update custom data api call functionality
  const CustomeDataUpdate = async (reftab, ConsignId, values) => {
    setLoading(true);
    try {
      // Loop through all custom fields
      for (const field of customFields) {
        const fieldName = field.FIELDNAME.replace(/\s+/g, "_").toLowerCase();
        const value = values?.[fieldName];

        // Find the existing custom data for this field and entity
        const existing = AllCustomeData?.find(
          (item) =>
            Number(item.REFID) === Number(ConsignId) &&
            Number(item.CFID) === Number(field.CFID),
        );

        // Only update if value is present and there is an existing record
        if (value !== undefined && value !== "") {
          if (existing) {
            // UPDATE
            const payload = {
              CfId: Number(field.CFID),
              RefId: ConsignId,
              Value: value,
              DataId: existing.DATAID,
            };
            await CALL_API("PATCH", "mastertable/updateCustomData", payload);
          } else {
            // INSERT
            await CustomeDataCreate(reftab, ConsignId, values);
          }
        }
      }
    } catch (error) {
      console.error("Error updating custom fields:", error);
    } finally {
      setLoading(false);
    }
  };

  //Delete custom data api call functionality
  const CustomeDataDelete = async (reftab, ConsignId) => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "DELETE",
        `mastertable/deleteCustomDataByRef`,
        {
          RefId: ConsignId,
          RefTab: reftab,
          McId: userInfo?.MCID,
        },
      );
    } catch (error) {
      console.error("Error deleting custom field:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadCustomFields(reftab);
    GetAllCustomeData(reftab);
  }, [reftab]);
  const [isconfigModalVisible, setIsconfigModalVisible] = useState(false);
  const [configId, setconfigId] = useState(null); // To store the ID of the consignment to delete

  const handleclickconfig = (id) => {
    setIsconfigModalVisible(true);
  };

  const handleUpload = async (file) => {
    const formData = new FormData();
    formData.append("file", file); // 'file' is the key your backend will expect
    formData.append("mcId", userInfo?.MCID); // Append MCID if needed for backend processing
    formData.append("type", "AICONSIGNMENT"); // Append UserId if needed for backend processing
    try {
      setLoading(true);
      const response = await axios.post(
        "https://ks5jby85id.execute-api.us-east-2.amazonaws.com/Prod/consignment/import",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: window?.localStorage?.getItem("token") || "",
          },
        },
      );
      if (response.status === 200) {
        const result = response.data?.data;
        const failedRows = result?.FailedRows || [];

        if (failedRows.length === 0) {
          message.success("CSV imported successfully!");
        } else {
          failedRows.forEach((item) => {
            let errorMessage = item.error;

            // Handle duplicate key error
            if (errorMessage.includes("UX_Container_Route")) {
              const match = errorMessage.match(
                /duplicate key value is \((.*?),\s*(.*?)\)/i,
              );

              const containerNo = match?.[1] || "Unknown";
              const routeId = match?.[2] || "Unknown";

              errorMessage = `Duplicate ContainerNo "${containerNo}" already exists for this Route.`;
            }

            message.error(
              `Row ${item.row ? item.row : ""}: ${errorMessage}`,
              8,
            );
          });

          message.warning(
            `Import completed with ${failedRows.length} failed row(s).`,
            8,
          );
        }

        getAssignedConsignments();
        setLoading(false);
      } else {
        message.error("Failed to import CSV.");
        setLoading(false);
      }
    } catch (error) {
      console.error("Upload error:", error);
      message.error(
        error.response?.data?.data?.errors[0].message ||
          "Something went wrong during upload.",
      );
    }

    return false; // Prevent default upload behavior
  };

  //device and route list functionality
  const [routeList, setRouteList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const [tripMonitorData, setTripMonitorData] = useState([]);

  const fetchAllCompany = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllCompany");
      setCompanyList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllCompany] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAllVehicle = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllVehicle");
      setVehicleList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  const fetchAllRoute = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllRoute");
      setRouteList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAllDevice = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllDevice");
      const devices = data?.companies || [];
      setDeviceList(devices);

      // Extract FGUIDs from devices
      const fguids = devices.map((d) => d.FGUID).filter(Boolean);

      // If we have FGUIDs, call trip monitor
      if (fguids.length > 0) {
        fetchTripMonitor(fguids);
      }
    } catch (error) {
      console.error("[fetchAllDevice] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchTripMonitor = useCallback(async (aDevices) => {
    try {
      const { data } = await CALL_API("POST", "container/tripMonitorList", {
        aDevices,
      });
      setTripMonitorData(data?.Result || []);
    } catch (error) {
      console.error("[fetchTripMonitor] error:", error);
    }
  }, []);

  useEffect(() => {
    fetchAllCompany();
    fetchAllVehicle();
    fetchAllRoute();
    fetchAllDevice();
  }, []);

  //fectch  vehicle,device,route per company
  const [filteredVehicleList, setFilteredVehicleList] = useState([]);
  const [filteredDeviceList, setFilteredDeviceList] = useState([]);
  const [filteredRouteList, setFilteredRouteList] = useState([]);
  const [filteredFenceList, setFilteredFenceList] = useState([]);
  const handleCompanyChange = (companyId) => {
    try {
      if (!companyId) {
        setFilteredVehicleList([]);
        setFilteredDeviceList([]);
        setFilteredRouteList([]);
        setFilteredFenceList([]);
        return;
      }

      const filteredFences = fenceList.filter(
        (v) => v.FAgentGUID === companyId,
      );
      const filteredVehicles = vehicleList.filter(
        (v) => v.FAgentGUID === companyId,
      );
      const filteredDevices = deviceList.filter(
        (d) => d.FAgentGUID === companyId,
      );
      const filteredRoutes = routeList.filter(
        (r) => r.FAgentGUID === companyId,
      );
      setFilteredVehicleList(filteredVehicles);
      setFilteredDeviceList(filteredDevices);
      setFilteredRouteList(filteredRoutes);
      setFilteredFenceList(filteredFences);
    } catch (error) {
      console.error("[handleCompanyChange] error:", error);
    }
  };
  useEffect(() => {
    handleCompanyChange(
      userInfo?.MCID === 59 ? formData?.company : userInfo?.ECTSCompId || "",
    );
  }, [formData.company, vehicleList, deviceList, routeList]);
  // useEffect(() => {
  //   if (
  //     userInfo?.ECTSCompId &&
  //     vehicleList.length > 0 &&
  //     deviceList.length > 0 &&
  //     routeList.length > 0
  //   ) {

  //     form.setFieldsValue({ company: userInfo.ECTSCompId });

  //     handleCompanyChange(userInfo.ECTSCompId);
  //   }
  // }, [userInfo, vehicleList, deviceList, routeList]);
  useEffect(() => {
    if (userInfo?.ECTSCompId) {
      form.setFieldsValue({ company: userInfo.ECTSCompId });
    }
  }, [userInfo?.ECTSCompId]);
  const [vehicleOptionss, setVehicleOptions] = useState([]); // for vehicle dropdown
  const [deviceOptionss, setDeviceOptions] = useState([]); // for device dropdown

  // const handleVehicleChange = async (vehicleFGUID) => {
  //   const selectedVehicle = vehicleList.find(
  //     (item) => item.FGUID === vehicleFGUID
  //   );

  //   if (!selectedVehicle) return;

  //   setLoading(true);
  //   try {
  //     const res = await CALL_API("POST", "ai/getDeviceInfo", {
  //       FVehicleName: selectedVehicle.FVehicleName,
  //     });

  //     const company = res?.data?.companies?.[0];

  //     if (company?.FAssetID) {
  //       const newDevices = [
  //         {
  //           label: company.FAssetID,
  //           value: company.FAssetID,
  //         },
  //       ];
  //       setDeviceList([
  //         { FGUID: company.FAssetID, FAssetID: company.FAssetID },
  //       ]);

  //       setTimeout(() => {
  //         tripform.setFieldValue("device", company.FAssetID);
  //         form.setFieldValue("device", company.FAssetID);
  //         setFormData((prevData) => ({
  //           ...prevData,
  //           device: company.FAssetID,
  //         }));
  //       }, 0);
  //       // setDrawerOpen(false);
  //     } else {
  //       setDeviceOptions([]);
  //       // tripform.setFieldValue();
  //       // form.setFieldsValue();
  //     }
  //   } catch (error) {
  //     setDeviceOptions([]);
  //     // tripform.setFieldValue({ device: undefined });
  //     // form.setFieldsValue({ addEdit: { device: undefined } });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const handleDeviceChange = async (FAssetID) => {
  //   const selectedDevice = filteredDeviceList.find(
  //     (item) => item.FAssetID === FAssetID
  //   );

  //   if (!selectedDevice) return;

  //   setLoading(true);

  //   try {
  //     // Fetch vehicle info based on assetID
  //     const res = await CALL_API("POST", "ai/getVehicleInfo", {
  //       FAssetID: selectedDevice.FAssetID,
  //     });
  //     const company = res?.data?.companies?.[0];

  //     if (company?.FGUID && company?.FVehicleName) {
  //       const newVehicle = [
  //         {
  //           label: company.FVehicleName,
  //           value: company.FVehicleName,
  //         },
  //       ];

  //       setVehicleOptions(newVehicle);

  //       // Auto-set vehicle field
  //       setTimeout(() => {
  //         form.setFieldValue("vehicle", company.FVehicleName);
  //         tripform.setFieldValue("vehicle", company.FVehicleName);
  //         setFormData((prevData) => ({
  //           ...prevData,
  //           vehicle: company.FVehicleName,
  //         }));

  //       }, 0);
  //     } else {
  //       console.warn("No vehicle found. Clearing vehicle field.");
  //       setVehicleOptions([]);
  //       form.setFieldValue("vehicle", undefined);
  //       tripform.setFieldValue("vehicle", undefined);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching vehicle info:", error);
  //     setVehicleOptions([]);
  //     form.setFieldValue("vehicle", undefined);
  //     tripform.setFieldValue("vehicle", undefined);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleVehicleChange = async (vehicleFGUID) => {
    const selectedVehicle = filteredVehicleList.find(
      (item) => item.FGUID === vehicleFGUID,
    );
    if (!selectedVehicle) return;

    const driverName = selectedVehicle.FDriverName || undefined;
    tripform.setFieldValue("driver", driverName);
    form.setFieldValue("driver", driverName);
    setFormData((prev) => ({
      ...prev,
      driver: selectedVehicle.FDriverName || "",
    }));

    setLoading(true);
    try {
      const res = await CALL_API("POST", "ai/getDeviceInfo", {
        FVehicleName: selectedVehicle.FVehicleName,
      });
      const company = res?.data?.companies?.[0];
      if (company?.FAssetID) {
        tripform.setFieldValue("device", company.FAssetID);
        form.setFieldValue("device", company.FAssetID);
        setFormData((prev) => ({ ...prev, device: company.FAssetID }));
      } else {
        tripform.setFieldValue("device", undefined);
        form.setFieldValue("device", undefined);
        setFormData((prev) => ({ ...prev, device: undefined }));
      }
    } catch (err) {
      tripform.setFieldValue("device", undefined);
      form.setFieldValue("device", undefined);
      setFormData((prev) => ({ ...prev, device: undefined }));
    } finally {
      setLoading(false);
    }
  };
  const handleDeviceChange = async (assetId) => {
    const selectedDevice = filteredDeviceList.find(
      (d) => d.FAssetID === assetId,
    );
    if (!selectedDevice) return;
    setLoading(true);
    try {
      const res = await CALL_API("POST", "ai/getVehicleInfo", {
        FAssetID: selectedDevice.FAssetID,
      });
      const company = res?.data?.companies?.[0];

      if (company?.FGUID) {
        tripform.setFieldValue("vehicle", company.FGUID);
        setFormData((prev) => ({ ...prev, vehicle: company.FGUID }));
      } else {
        tripform.setFieldValue("vehicle", undefined);
      }
    } catch (err) {
      tripform.setFieldValue("vehicle", undefined);
    } finally {
      setLoading(false);
    }
  };
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const createAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "CRC"),
    [reduxPermissions],
  );
  const updateAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "UPC"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "DC"),
    [reduxPermissions],
  );
  const copyAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "CYC"),
    [reduxPermissions],
  );
  const importAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "IC"),
    [reduxPermissions],
  );
  const exportAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "EX"),
    [reduxPermissions],
  );
  const assignAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "CAT"),
    [reduxPermissions],
  );

  const addTripAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "AT"),
    [reduxPermissions],
  );

  const companyOptions = companyList.map((item) => ({
    value: item.FAgentGUID,
    label: item.FName,
  }));
  const vehicleOptions = filteredVehicleList.map((item) => ({
    value: item.FGUID,
    label: item.FVehicleName,
    vehicleTypeId: item.FVehicleTypeID,
    DriverName: item.FDriverName,
  }));
  const routeOptions = filteredRouteList.map((item) => ({
    value: item.FRouteGUID,
    label: item.FRouteName,
  }));
  const deviceOptions = filteredDeviceList.map((item) => ({
    value: item.FAssetID,
    label: item.FAssetID,
  }));

  const handleTripCreate = async (values) => {
    setLoading(true);
    try {
      const selectedVehicle = vehicleOptions.find(
        (v) => String(v.value) === String(values.vehicle),
      );
      const vehRegNo = selectedVehicle?.label || "";
      const vehTypeId = selectedVehicle?.vehicleTypeId || null;
      const Drivername = values.driver || selectedVehicle?.DriverName || "";

      const deviceName =
        deviceOptions.find((d) => String(d.value) === String(values.device))
          ?.label || "";

      const routeName =
        routeOptions.find((r) => String(r.value) === String(values.route))
          ?.label || "";

      const companyName =
        companyOptions.find((c) => String(c.value) === String(values.company))
          ?.label || "";

      const FVehicleGUID = vehicleList?.find(
        (v) => v.FVehicleName === values.vehicle,
      )?.FGUID;
      const FDeviceGUID =
        filteredDeviceList?.find((d) => d.FAssetID === values.device)?.FGUID ||
        "";
      const {
        data,
        ResponseCode,
        message: Message,
      } = await CALL_API("POST", "ai/trip/createTrip", {
        McId: userInfo?.MCID,
        Company: userInfo?.MCID === 59 ? companyName : userInfo?.COMPNAME || "",
        //DeliverNo:values.deliverNo,
        // VehId: FVehicleGUID,
        // VehRegNo:  values.vehicle,
        // VTypeId: vehTypeId,
        VehId: values.vehicle,
        VehRegNo: vehRegNo,
        VTypeId: vehTypeId,
        DriverName: Drivername,
        Remarks: values.remark,
        userId: userInfo?.UID,
        TripType: values.tripType,
        DispatchTypeID: values.dispatchtype.toString(),
        FinishType: values.finishtype,
        ShipmentTypeId: values.shipmentType,
        TripAllowance: values.tripallowance,
        FuelQuantity: values.fuelQuantity,
        DeviceID: FDeviceGUID,
        DeviceName: values.device,
        RouteID: values.route,
        RouteName: routeName,
        FWayBill: values.deliveryNo,
        PickUpDateTime: values.pdate,
        DropOffDateTime: values.ddate,
        // ConsignId: values.ConsignId,
        ConsignmentIds: selectedRowKeys,
      });

      const TripId = data?.TripId || data?.TRIPID || data?.result?.TRIPID;
      // Save custom fields for the trip
      if (TripId) {
        await CustomeTripDataCreate(TripId, values);
        tripform?.resetFields();
        setIsCreateTrip(false);
        setSelectedRows([]);
        setSelectedRowKeys([]);
        setIsDeviceDisabled(true);
        await getAssignedConsignments();
        message.success("Trip created successfully!");
      } else if (ResponseCode !== 200) {
        message.warning(data);
      } else {
        console.error("TripId not found in API response:", data);
        message.error(data);
      }

      setLoading(false);
    } catch (error) {
      console.error("[handleTripCreate] error -->", error);
      message.error("Failed to create trip. Please try again.");
      setLoading(false);
    }
  };

  const handleTooltipVisibleChangeExport = (visible) => {
    setVisibleExport(visible);
    hideTooltipArrow();
  };

  const handleTooltipVisibleChangeImport = (visible) => {
    setVisibleImport(visible);
    hideTooltipArrow();
  };

  const handleTooltipVisibleChangeSort = (visible) => {
    setVisibleSort(visible);
    hideTooltipArrow();
  };

  // const hideTooltipArrow = () => {
  //   setTimeout(() => {
  //     const tooltipArrows = document.querySelectorAll(".ant-tooltip-arrow");
  //     tooltipArrows.forEach((arrow) => {
  //       arrow.style.display = "none";
  //     });
  //   }, 0);
  // };

  const hideTooltipArrow = () => {
    setTimeout(() => {
      const tooltipArrows = document.querySelectorAll(".ant-tooltip-arrow");
      tooltipArrows.forEach((arrow) => {
        arrow.style.display = "none";
      });
    }, 0);
  };

  const [sortField, setSortField] = useState(null);

  const handleSortOptionChange = (value) => {};
  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "label1",
  ); // Default to "Assigned"
  const [consignee, setConsignee] = useState(null);
  const [hoveredrow, setHoveredrow] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [assignModal, setAssignModal] = useState(false);
  const [copyId, setCopyId] = useState(null);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setFormData((prevValue) => ({ ...prevValue, [name]: value }));
  };
  const csvLinkEl = useRef();

  const [isEditing, setIsEditing] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [assignVehicleId, setAssignVehicleId] = useState(null);
  const [assignDriverId, setAssignDriverId] = useState([]);
  const [getCodebyvehicle, setCodebyVehicle] = useState([]);
  const [getcode, setGetcode] = useState(null);
  const [codeList, setCodeList] = useState([]);
  const [selectedTripCode, setSelectedTripCode] = useState(null);
  const [assignTripId, setAssignTripId] = useState(null);
  const [pickupDropoffLocations, setPickupDropoffLocations] = useState([]);
  const getpickupDropoff = async () => {
    try {
      const { data } = await CALL_API(
        "GET",
        `consign/getpickupDropofflocation?ENTID=${formData?.consignor}&MCID=${userInfo?.MCID}`,
        {},
      );
      const locations = Array.isArray(data?.data) ? data.data : [];
      // setPickupDropoffLocations(data || []);
      setFormData((prev) => ({
        ...prev,
        plocation: data?.[0]?.ADDRESS,
        plocationname: {
          latitude: data?.[0]?.LATITUDE || 0,
          longitude: data?.[0]?.LONGITUDE || 0,
          place_name: data?.[0]?.ADDRESS || 0,
        },
      }));
      AddEditFormm?.setFieldValue("plocation", locations[0]?.ADDRESS);
      BulkCreateForm?.setFieldValue("plocation", locations[0]?.ADDRESS);
    } catch (error) {
      console.error("getpickupDropoff error -->", error);
    }
  };
  const [locationCache, setLocationCache] = useState({});
  const getpickupDrop = async () => {
    try {
      const { data } = await CALL_API(
        "GET",
        `consign/getpickupDropofflocation?ENTID=${formData?.consignee}&MCID=${userInfo?.MCID}`,
        {},
      );
      // setPickupDropoffLocations(data || [])
      // setFormData((prev) => ({
      //   ...prev,
      //   dlocation: data?.[0]?.ADDRESS,
      //   dlocationname: {
      //     latitude: data?.[0]?.LATITUDE || 0,
      //     longitude: data?.[0]?.LATITUDE || 0,
      //     place_name: data?.[0]?.ADDRESS || 0,
      //   },
      // }));
    } catch (error) {
      console.error("getpickupDropoff error -->", error);
    }
  };

  useEffect(() => {
    getpickupDropoff();
  }, [formData?.chargetype, formData?.consignor]);

  useEffect(() => {
    if (formType === "addEdit") {
      getpickupDrop();
    }
  }, [formData?.consignee]);

  const onTripCodeSelect = (code) => {
    setSelectedTripCode(code);
    const selected = codeList?.find((item) => item?.Code === code);
    if (selected) {
      setAssignTripId(selected?.TripId);
    }
  };
  const getCodeByVehicleId = async (vehicleId) => {
    try {
      const { data } = await CALL_API(
        "GET",
        `aiconsign/getCodebyVehicle?VehRegNo=${assignVehicleId}`,
        {},
      );
      setCodeList(data || []);
    } catch (error) {
      console.error("getCodeByVehicleId error -->", error);
    }
  };

  const driveridone = driverWithVehicle?.find(
    (vehicle) => vehicle?.VEHID === assignVehicleId,
  );
  useEffect(() => {
    getCodeByVehicleId();
  }, [assignVehicleId]);

  const AssignedVehicle = async () => {
    if (!assignTripId) {
      message.warning("Please select a trip code.");
      return;
    }

    setLoading(true);
    const { data } = await CALL_API("POST", `aiconsignment/assign_trip`, {
      TripId: assignTripId,
      ConsignmentIds: selectedRowKeys,
      UserId: userInfo?.UID,
      // vehicleId: getcode,
    });
    setAssignModal(false);
    setSelectedRowKeys([]);
    getAssignedConsignments();
    setLoading(false);

    message.success("Trip assigned successfully.");
  };

  // const getCodeByVehicle = async (vehicleId) => {
  //   try {
  //     const { data } = await CALL_API(
  //       "GET",
  //       `consign/getCodebyVehicle?vehicleId=${vehicleId}`,
  //       {}
  //     );
  //     setCodeList(data || []);
  //   } catch (error) {
  //     console.error("getCodeByVehicleId error -->", error);
  //   }
  // };

  // useEffect(() => {
  //   getCodebyVehicle();
  // }, []);
  const editUser = (record) => {
    setIsEditing(true);
    setFormData(record);
    setDrawerOpen(true);
  };

  const handleCancel = () => {
    setIsEdit(false);
    setConsignee(false);
    setDrawerOpen(false);
    setFormType("");
    setFormData({
      company: userInfo?.MCID === 59 ? "" : userInfo.COMPNAME,
      ConsignorName: "",
      consignor:
        userInfo?.MCID === 71
          ? 14045
          : userInfo?.MCID === 46
            ? 32921
            : userInfo?.MCID === 55
              ? 1
              : "",
      transporter:
        userInfo?.MCID === 71
          ? 14046
          : userInfo?.MCID === 46
            ? 32922
            : userInfo?.MCID === 55
              ? 2
              : userInfo?.MCID === 3
                ? 91
                : userInfo?.MCID === 78 || userInfo?.MCID === 72
                  ? 2
                  : "", // Auto-select for MCID 71
      consignee: [{}],
      chargetype:
        userInfo?.MCID === 46 || userInfo?.MCID === 55
          ? 6
          : userInfo?.MCID === 3 ||
              userInfo?.MCID === 72 ||
              userInfo?.MCID === 78
            ? 3
            : "",
      priority: userInfo?.MCID === 55 ? 1 : "",
      noofdeliverables: "",
      dimension: "",
      gross: "",
      switch: false,
      plocation: "",
      pdate: userInfo?.MCID === 55 ? dayjs(timeNow) : "",
      dlocation: "",
      ddate: userInfo?.MCID === 55 ? dayjs(afterOneHour) : "",
      fence: [{}],
      pnotes: "",
      dnotes: "",
      remark: "",
      linkdossier: "",
      orderno: "",
      referenceno: "",
      containerno: "",
      zone: "",
      shipmentType:
        userInfo?.MCID === 71 ||
        userInfo?.MCID === 46 ||
        userInfo?.MCID === 55 ||
        userInfo?.MCID === 78
          ? 1
          : userInfo?.MCID === 3
            ? 2
            : "",
      dispatchtype:
        userInfo?.MCID === 46 ||
        userInfo?.MCID === 55 ||
        userInfo?.MCID === 3 ||
        userInfo?.MCID === 78 ||
        userInfo?.MCID === 72
          ? "0"
          : "",
      tripType:
        userInfo?.MCID === 55 || userInfo?.MCID === 78
          ? 1
          : userInfo?.MCID === 3
            ? 2
            : "",
      tripallowance: "",
      finishtype:
        userInfo?.MCID === 71 || userInfo?.MCID === 46 || userInfo?.MCID === 55
          ? 5
          : userInfo?.MCID === 3 || userInfo?.MCID === 72
            ? 0
            : userInfo?.MCID === 78
              ? 1
              : "",
      fuelQuantity: "",
      vehicle: "",
      device: "",
      route: "",
      deliveryNo: "",
      dlocationname: {},
      plocationname: {},
      ReferenceNo: "",
      ContainerNo: "",
      driver: "",
    });
    form.resetFields();
  };

  const handleClickme = (record) => {
    setHoveredrow(record.key);
  };
  const handleClickeditdrawer = (event, record) => {
    setDrawerOpen(true);
    event.stopPropagation();
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    setPageSize(10);
    setCurrentPage(1);
    setSelectedKeys([]);
  };

  const [selectedKeys, setSelectedKeys] = useState([]);

  const handleCheckboxChange = (key) => {
    setSelectedKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
    );
  };

  const [selectedRows, setSelectedRows] = useState([]);

  // const rowSelection = {
  //   onChange: (selectedRowKeys, selectedRows) => {
  //     setSelectedRows(selectedRowKeys);
  //   },
  // };

  const [showModal, SetshowModal] = useState(false);

  const [resolveModal, setResolveModal] = useState(false);
  const [sortFields, setSortFields] = useState([]);
  const [sortColumns, setSortColumns] = useState([]);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [isBulkDeleteModalVisible, setIsBulkDeleteModalVisible] =
    useState(false);
  const handleresolveopen = () => {
    setResolveModal(true);
  };

  const handleresolveclose = () => {
    setResolveModal(false);
  };
  const handleclickme = () => {
    SetshowModal(true);
  };

  const handlecancelmodal = () => {
    SetshowModal(false);
  };

  const closeEditModal = () => {
    setResolveModal(false);
  };
  const editModuleupdate = () => {
    setFilterData({
      code: "",
      priority: "",
      consignee: "",
      consignor: "",
      driver: "",
      duration: "current_month",
      event: "",
      town: "",
      transporter: "",
      vehicle: "",
      shipment: "",
      ContainerNo: "",
      containerno: "",
      referenceno: "",
      daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
    });
    filterform.setFieldsValue({
      code: "",
      priority: "",
      consignee: "",
      consignor: "",
      driver: "",
      duration: "current_month",
      event: "",
      town: "",
      transporter: "",
      shipment: "",
      containerno: "",
      ContainerNo: "",
      referenceno: "",
      vehicle: "",
      daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
    });
  };

  const handleLocationSelect = (location) => {
    if (!location || !location.center) return;

    const [longitude, latitude] = location.center;

    setFormData((prev) => ({
      ...prev,
      [selectedItem]: location.place_name,
      [`${selectedItem}name`]: {
        place_name: location.place_name,
        latitude,
        longitude,
      },
    }));

    setLocationModal(false);
  };

  const selectedColumns = [
    {
      title: "Date",
      dataIndex: "cron",
      key: "cron",
      render: (text) => {
        return moment(text).format("Do MMM YYYY; hh:mm A");
      },
    },
    {
      title: "Consign Code",
      dataIndex: "Code",
      key: "Code",
    },
    {
      title: "Pickup Location",
      dataIndex: "StartLocation",
      key: "StartLocation",
    },
    {
      title: "Dropoff Location",
      dataIndex: "EndLocation",
      key: "EndLocation",
    },
    {
      title: "Pickup Date Time",
      dataIndex: "PickUpDateTime",
      key: "PickUpDateTime",
      render: (text) => {
        return moment(text).format("Do MMM YYYY; hh:mm A");
      },
    },
    {
      title: "Dropoff Date Time",
      dataIndex: "DropOffDateTime",
      key: "DropOffDateTime",
      render: (text) => {
        return moment(text).format("Do MMM YYYY; hh:mm A");
      },
    },
    {
      title: "Volume",
      dataIndex: "location",
      key: "location",
    },
  ];
  const getFieldType = (type) => {
    const typeMap = {
      1: "selectwithvalue", // Dropdown
      2: "text", // Textbox
      3: "checkbox", // Checkbox
    };
    return typeMap[type] || "text";
  };

  const chunkArray = (arr, size = 3) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      const row = arr.slice(i, i + size);
      while (row.length < size) {
        row.push({}); // Empty field to maintain layout
      }
      chunks.push(row);
    }
    return chunks;
  };

  const handleDownloadCSVTemplate = () => {
    const headers = [
      "Company",
      "VehicleRegNo",
      "TripType",
      "ShipmentTypeId",
      "FinishType",
      "DispatchType",
      "DeliveryNotesNo",
      "TripAllowance",
      "FuelQuantity",
      "ConsignorName",
      "TransporterName",
      "RouteName",
      "DispatchTypeName",
      "FWayBill",
      "ReferenceNo",
      "ContainerNo",
      "ConsignmentReference",
      "FName",
      "GrossWeight",
      "GrossVolume",
      "ConsignmentPickUpDateTime",
      "ConsignmentDropOffDateTime",
      "ChargeType",
      "PickUpNote",
      "DropOffNote",
      "Remarks",
      "Priority",
    ];

    const csvContent = [headers.join(",")].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "consignment_template.csv");

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    message.info("Template downloaded successfully!");
  };

  const dynamicCustomColumns = useMemo(() => {
    if (!Array.isArray(customFields) || customFields.length === 0) return [];
    return customFields
      .filter((field) => selectedCustomColumns.includes(field.CFID))
      .map((field) => ({
        title: field.FIELDNAME,
        dataIndex: field.CFID,
        key: field.CFID,
        sorter: false,
        render: (text) => text || "-",
      }));
  }, [customFields, selectedCustomColumns]);
  const customFieldOptions = Array.isArray(customFields)
    ? customFields.map((field) => ({
        label: field.FIELDNAME,
        value: field.CFID,
        disabled: false,
      }))
    : [];
  const [expandedRows, setExpandedRows] = useState({});

  const toggleViewMore = (key) => {
    setExpandedRows((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  const baseColumns = [
    {
      title: "Date",
      dataIndex: "cron",
      key: "cron",
      // sorter: sortFields?.includes("Date")
      //   ? (a, b) => new Date(b.cron) - new Date(a.cron)
      //   : false,
      render: (value) => {
        if (!value) return "-";

        const d = new Date(value);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        return `${day}-${month}-${year}`;
      },
    },
    {
      title: "Consign Code",
      dataIndex: "Code",
      key: "Code",
      // sorter: sortFields?.includes("Order No")
      //   ? (a, b) => a.Code.localeCompare(b.Code)
      //   : false,

      render: (code, record) => {
        return (
          <>
            <p>{code}</p>
          </>
        );
      },
    },
    {
      title: "Vehicle / Driver",
      dataIndex: "DriverName",
      key: "DriverName",
      render: (text, record) => (
        <div>
          <p>{record?.VehRegNo || ""}</p>
          <p style={{ fontStyle: "italic", color: "#5F6D8C" }}>{text || ""}</p>
        </div>
      ),
    },
    {
      title: "Event",
      dataIndex: "LastModify",
      key: "LastModify",
      render: (text, record) => {
        const isCollection = record.ShipmentType === 2;
        const EventType = isCollection
          ? AIConsignmentCollectionEvents
          : AIConsignmentDeliveryEvents;
        const event = EventType.find((item) => item.value === text);
        return event
          ? event.name
          : activeTab === "label2"
            ? "Unassigned"
            : "Assigned";
      },
    },

    {
      title: "Consignor",
      dataIndex: "CustName",
      key: "CustName",
      // sorter: sortFields?.includes("consignee")
      //   ? (a, b) => a.CustName.localeCompare(b.CustName)
      //   : false,
      ellipsis: false, // Disable truncation to allow wrapping
      render: (text) => <div className="text-wrap">{text}</div>, // Wrap text
    },
    {
      title: "Consignee",
      dataIndex: "FNAME",
      key: "FNAME",
      // sorter: sortFields.includes("FNAME")
      //   ? (a, b) => a.FNAME.localeCompare(b.FNAME)
      //   : false,
      ellipsis: false, // Disable truncation to allow wrapping
      render: (text) => <div className="text-wrap">{text}</div>, // Wrap text
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      // width: "20%",
      sorter: sortFields.includes("Location")
        ? (a, b) => a.location.localeCompare(b.location)
        : false,
      render: (_, record) => {
        const key = record.key;
        const isExpanded = expandedRows[key];
        const isFinished = record.LastModify === 16;

        return (
          <LocationCell
            startLat={isFinished ? record.StartLat : record.FLatitude}
            startLng={isFinished ? record.StartLng : record.FLongitude}
            endLat={isFinished ? record.ELAT : record.FLatitude}
            endLng={isFinished ? record.ELNG : record.FLongitude}
            locationCache={locationCache}
            setLocationCache={setLocationCache}
            renderText={(locationText) => {
              const truncated =
                locationText?.length > 50 && !isExpanded
                  ? `${locationText.substring(0, 50)}...`
                  : locationText;

              return (
                <div>
                  <p
                    style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                  >
                    {truncated}
                  </p>

                  {locationText?.length > 50 && (
                    <span
                      style={{ color: "#2C963D", cursor: "pointer" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleViewMore(key);
                      }}
                    >
                      {isExpanded ? "View Less" : "View More"}
                    </span>
                  )}
                </div>
              );
            }}
          />
        );
      },
    },
    // ...(userInfo?.MCID === 72
    //   ? [
    {
      title: "Container No",
      dataIndex: "ContainerNo",
      key: "ContainerNo",
      render: (text) => <div className="">{text ? text : "-"}</div>,
    },
    {
      title: "Reference No",
      dataIndex: "ReferenceNo",
      key: "ReferenceNo",
      render: (text) => <div className="">{text ? text : "-"}</div>,

      // sorter: sortFields.includes("ReferenceNo")
      //   ? (a, b) => a.ReferenceNo.localeCompare(b.ReferenceNo)
      //   : false,
    },
    {
      title: "Delivery Note No",
      dataIndex: "FWayBill",
      key: "FWayBill",
      // sorter: sortFields.includes("FWayBill")
      //   ? (a, b) => a.FWayBill.localeCompare(b.FWayBill)
      //   : false,
    },
    //   ]
    // : []),
  ];
  const combinedColumns = useMemo(() => {
    const staticCols = [...baseColumns];

    // Only show custom fields that are selected
    const dynamicCols = customFields
      .filter((field) => selectedCustomColumns.includes(field.CFID))
      .map((field) => ({
        title: field.FIELDNAME,
        dataIndex: field.CFID,
        key: field.CFID,
        sorter: false,
        render: (_, record) => record?.[field.CFID] ?? "-",
      }));

    return [...staticCols, ...dynamicCols];
  }, [baseColumns, customFields, selectedCustomColumns]);

  const transporterColumn = {
    title: "Transporter",
    dataIndex: "SupName",
    key: "SupName",
    // sorter: (a, b) =>
    //   sortFields.includes("SupName")
    //     ? a.SupName.localeCompare(b.SupName)
    //     : false,
    ellipsis: false, // Disable truncation to allow wrapping
    render: (text) => {
      // Check if `text` is an array and remove duplicates
      const uniqueText = Array.isArray(text) ? [...new Set(text)] : [text];
      return (
        <div className="text-wrap">
          {uniqueText.join(", ")} {/* Join unique values with a comma */}
        </div>
      );
    },
  };

  const actionsColumn = {
    title: "Actions",
    key: "actions",
    width: "10%",
    fixed: "right",
    render: (_, record) => (
      <div>
        <Tooltip title={!copyAllowed ? "No permission" : ""}>
          <CopyIcon
            style={{ cursor: copyAllowed ? "pointer" : "not-allowed" }}
            onClick={(e) => {
              if (!copyAllowed) return;
              e.stopPropagation();
              setIsConformationModal(true);
              setCopyId(record?.ConsignId);
            }}
          />
        </Tooltip>
        <Tooltip title={!updateAllowed ? "No permission" : ""}>
          <EditIcon
            style={{
              cursor: updateAllowed ? "pointer" : "not-allowed",
              marginLeft: "10px",
            }}
            onClick={(e) => {
              if (!updateAllowed) return;
              e.stopPropagation();
              // Map existing custom field values from the row into formData
              // using the same lowercase FIELDNAME keys used in the form.
              const customFieldValues = {};
              (Array.isArray(customFields) ? customFields : []).forEach(
                (field) => {
                  const fieldKey = field.FIELDNAME?.replace(
                    /\s+/g,
                    "_",
                  ).toLowerCase();
                  if (!fieldKey) return;
                  const value = record?.[field.CFID];
                  if (value !== undefined) {
                    customFieldValues[fieldKey] = value;
                  }
                },
              );
              setFormData({
                chargetype: record?.ChargeType,
                consignor: consignerList?.find(
                  (item) => item?.Name === record?.CustName,
                )?.ID,
                ddate: dayjs(record?.DropOffDateTime),
                dropoffnotes: record?.DropOffNote,
                dlocation: record?.EndLocation,
                gross: record?.GrossVolume,
                GrossWeight: record?.GrossWeight,
                switch: record?.ISDELOTP,
                pdate: dayjs(record?.PickUpDateTime),
                pickupnotes: record?.PickUpNote,
                priority: record?.Priority,
                transporter: transporterList?.find(
                  (item) => item?.Name === record?.SupName,
                )?.ID,
                remark: record?.Remarks,
                // consignee: consigneeList?.find(
                //   (item) => item?.Name === record?.RecName
                // )?.ID, // Map consignee to its ID
                consignee: null,
                fence: fenceList?.find((item) => item?.FGUID === record?.FID)
                  ?.FName,
                plocation: record?.StartLocation,
                TripId: record?.TripId,
                CrBy: record?.CrBy,
                ConsignId: record?.ConsignId,
                EndLat: record?.EndLat,
                EndLng: record?.EndLng,
                switch: false,
                StartLat: record?.StartLat,
                StartLng: record?.StartLng,
                dimension: record?.dimension,
                deliverables: record?.noofdeliverables,
                ReferenceNo: record?.ReferenceNo,
                ContainerNo: record?.ContainerNo,
                ...customFieldValues,
              });
              setIsEdit(true);
              setDrawerOpen(true);
            }}
          />
        </Tooltip>
        <Tooltip title={!deleteAllowed ? "No permission" : ""}>
          <DeleteIcon
            style={{
              cursor: deleteAllowed ? "pointer" : "not-allowed",
              marginLeft: "10px",
            }}
            onClick={(e) => {
              if (!deleteAllowed) return;
              e.stopPropagation();
              setDeleteId(record?.ConsignId); // Set the ID of the consignment to delete
              setIsDeleteModalVisible(true); // Show the delete confirmation modal
            }}
          />
        </Tooltip>
      </div>
    ),
  };

  useEffect(() => {
    if (consignmentRecord && Object.keys(consignmentRecord).length) {
      setConsignmentDetails(consignmentRecord);
      setConsignee(true);
    }
  }, [consignmentRecord]);
  useEffect(() => {
    if (filterform.getFieldValue("duration") === "last_month") {
      filterform.setFieldValue("daterange", [
        moment().subtract(1, "months").startOf("month"),
        moment().subtract(1, "months").endOf("month"),
      ]);
    } else if (filterform.getFieldValue("duration") === "current_month") {
      filterform.setFieldValue("daterange", [
        moment().startOf("month"),
        moment().endOf("month"),
      ]);
    } else if (filterform.getFieldValue("duration") === "current_year") {
      filterform.setFieldValue("daterange", [
        moment().startOf("year"),
        moment().endOf("year"),
      ]);
    } else if (filterform.getFieldValue("duration") === "today") {
      filterform.setFieldValue("daterange", [moment(), moment()]);
    } else if (filterform.getFieldValue("duration") === "---") {
      filterform.setFieldValue("daterange", [null, null]);
    }
  }, [filterform.getFieldValue("duration")]);

  const additionalColumnForUnassigned = {
    title: <Checkbox />,
    dataIndex: "checkbox",
    key: "checkbox",
    width: "5%",
    render: (_, record) => (
      <Checkbox
        checked={selectedKeys.includes(record.key)}
        onChange={() => handleCheckboxChange(record.key)}
      />
    ),
  };

  const columnsForAssigned = [
    ...combinedColumns,
    transporterColumn,
    actionsColumn,
  ];
  const columnsForUnassigned = [
    // additionalColumnForUnassigned,
    ...combinedColumns.filter(
      (col) =>
        col.key !== "transporter" &&
        col.key !== "actions" &&
        col.key !== "DriverName" &&
        col.key !== "event",
    ),
    actionsColumn,
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedRows(selectedRows);
    },
  };

  const handleFilterChange = (e) => {
    const { value, name } = e.target;
    setFilterData((PrevValue) => ({ ...PrevValue, [name]: value }));
  };
  const handleFilterSelectChange = (field, value) => {
    setFilterData((prevData) => ({
      ...prevData,
      [value]: field,
    }));
    if (value === "shipment") {
      setFormData((prevData) => ({
        ...prevData,
        event: field,
      }));
      handleShipmentChange(field);
    }
  };

  const currentColumns =
    activeTab === "label1" ? columnsForAssigned : columnsForUnassigned;

  const handleClose = () => {
    setDrawerOpen(false);
  };

  const handleCreateClick = () => {
    handleCreateAnotherTrip();
    setFormType("addEdit");
    setDrawerOpen(true);
    setNewLoading(true);
  };

  const handleBulkCreateClick = () => {
    handleCreateAnotherTrip();
    setFormType("bulkCreate");
    setDrawerOpen(true);
  };
  const handleSelectChange = (value, field, fields, index = 0) => {
    if (fields === "list") {
      // setFormData((prevData) => {
      //   let updatedConsignee = [...prevData.consignee];
      //   if (updatedConsignee.length <= index) {
      //     updatedConsignee[index] = {};
      //   }
      //   updatedConsignee[index] = {
      //     ...updatedConsignee[index],
      //     [field]: value,
      //   };

      //   return {
      //     ...prevData,
      //     consignee: updatedConsignee,
      //   };
      // });
      setFormData((prevData) => {
        let updatedConsignee = [...prevData.fence];

        // Ensure the array has enough items for the selected index
        if (updatedConsignee.length <= index) {
          updatedConsignee[index] = {};
        }

        updatedConsignee[index] = {
          ...updatedConsignee[index],
          [field]: value,
        };

        return {
          ...prevData,
          fence: updatedConsignee,
        };
      });
    } else if (field === "company") {
      setFormData((prevData) => ({
        ...prevData,
        company: value,
      }));
      handleCompanyChange(value);
    } else if (field === "vehicle") {
      setFormData((prevData) => ({
        ...prevData,
        vehicle: value,
        device: null,
      }));

      handleVehicleChange(value); // fetch deviceOptions based on vehicle
    }
    //  else if (field === "device") {
    //   setFormData((prevData) => ({
    //     ...prevData,
    //     device: value,
    //   }));

    //   handleDeviceChange(value);
    // }
    else {
      setFormData((prevData) => ({
        ...prevData,
        [field]: value,
      }));
      form.setFieldValue(field, value);
    }
  };

  const isContainerAccount =
    Number(userInfo?.MCID) === 78 || Number(userInfo?.MCID) === 72;

  //Bulk creation add edit form
  const AddEditFormm = useMemo(() => {
    const mappedCustomFields = customFields?.map((field) => {
      const name = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
      const type = getFieldType(field.FIELDTYPE);
      let options;

      // For dropdowns, parse options from DATASOURCE or OPTIONS
      if (type === "selectwithvalue" && (field.DATASOURCE || field.OPTIONS)) {
        const source = field.DATASOURCE || field.OPTIONS;
        options = source
          .split(",")
          .map((opt) => ({
            label: opt.trim(),
            value: opt.trim(),
          }))
          .filter((opt) => opt.value); // Remove empty options
      }

      return {
        id: field.CFID,
        label: field.FIELDNAME,
        type,
        name,
        placeholder: field.FIELDNAME,
        maxLength: field.MAXLEN > 0 ? field.MAXLEN : undefined,
        validationRules: field.REQUIRED
          ? [{ required: true, message: `${field.FIELDNAME} is required` }]
          : [],
        value: formData[name] || "",
        onChange: handleChange,
        ...(options ? { options } : {}),
      };
    });
    const customFieldRows = chunkArray(mappedCustomFields || [], 3);
    const staticFields = [
      [
        {
          id: 1,
          label: "Company",
          type: "selectwithvalue",
          name: "company",
          disabled: Number(userInfo?.MCID) !== 59,
          options: companyOptions,
          maxLength: 50,
          style: { width: "259px", height: "36px", gap: "10px" },
          validationRules: [{ required: true, message: "Company is required" }],
          initialValue:
            Number(userInfo?.MCID) === 59
              ? formData?.company
              : formData?.company || userInfo?.ECTSCompId || "",
        },
        {
          id: 2,
          label: "Consignor",
          type: "selectwithvalue",
          name: "consignor",
          options:
            userInfo?.MCID === 71
              ? consignerList
                  ?.filter((item) => item.ID === 14045)
                  .map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))
              : userInfo?.MCID === 46
                ? consignerList
                    ?.filter((item) => item.ID === 32921)
                    .map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))
                : consignerList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  })),
          placeholder: "Consignor",
          style: "",
          disabled: userInfo?.MCID === 71 || userInfo?.MCID === 46,
          validationRules: [
            { required: true, message: "Consignor is required" },
          ],
          initialValue:
            userInfo?.MCID === 71
              ? 14045
              : userInfo?.MCID === 46
                ? 32921
                : userInfo?.MCID === 55
                  ? 1
                  : undefined,
        },
        {
          id: 3,
          label: "Transporter",
          type: "selectwithvalue",
          name: "transporter",
          options:
            userInfo?.MCID === 71
              ? transporterList
                  ?.filter((item) => item.ID === 14046)
                  .map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))
              : userInfo?.MCID === 46
                ? transporterList
                    ?.filter((item) => item.ID === 32922)
                    .map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))
                : transporterList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  })),
          placeholder: "Transporter",
          style: "",
          disabled: userInfo?.MCID === 71 || userInfo?.MCID === 46,
          validationRules: [
            { required: true, message: "Transporter is required" },
          ],
          initialValue:
            userInfo?.MCID === 71
              ? 14046
              : userInfo?.MCID === 46
                ? 32922
                : userInfo?.MCID === 55
                  ? 2
                  : userInfo?.MCID === 78
                    ? 2
                    : undefined,
        },
        {
          id: 4,
          label: "Charge Type",
          type: "selectwithvalue",
          name: "chargetype",
          options:
            userInfo?.MCID === 46
              ? chargetype
                  ?.filter((item) => item.value === 6)
                  .map((item) => ({
                    label: item.name,
                    value: item.value,
                  }))
              : userInfo?.MCID === 72
                ? chargetype
                    ?.filter((item) => item.value === 3)
                    .map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))
                : chargetype?.map((item) => ({
                    label: item.name,
                    value: item.value,
                  })),
          disabled: userInfo?.MCID === 46 || userInfo?.MCID === 72,
          style: "",
          validationRules: [
            { required: true, message: "Charge Type is required" },
          ],
          initialValue:
            userInfo?.MCID === 46 || userInfo?.MCID === 55
              ? 6
              : userInfo?.MCID === 3 ||
                  userInfo?.MCID === 72 ||
                  userInfo?.MCID === 78
                ? 3
                : undefined,
        },
      ],
      [
        {
          id: 5,
          label: "Trip Type",
          type: "selectwithvalue",
          name: "tripType",
          placeholder: "Local",
          onChange: handleChange,
          maxLength: 50,
          options:
            userInfo?.MCID === 72
              ? PanTripTypeEnum?.map((item) => ({
                  label: item.name,
                  value: item.value,
                }))
              : TripTypeEnum?.map((item) => ({
                  label: item.name,
                  value: item.value,
                })),
          initialValue: userInfo?.MCID === 78 ? 1 : undefined,
          validationRules: [
            { required: true, message: "Trip type is required" },
          ],
        },
        {
          id: 10,
          label: "Pickup Date & Time",
          type: "date",
          showtime: true,
          format: "YYYY-MM-DD HH:mm:ss",
          name: "pdate",
          placeholder: "24th Aug 2024; 07:10 AM",
          value: "formData.pdate",
          maxLength: 50,
          onChange: "",
          style: "",
          validationRules: [
            { required: true, message: "Pickup Date & Time is required" },
          ],
        },
        {
          id: 11,
          label: "Dropoff Date & Time",
          type: "date",
          name: "ddate",
          showtime: true,
          format: "YYYY-MM-DD HH:mm:ss",
          placeholder: "24th Aug 2024; 07:10 AM",
          value: "formData.ddate",
          maxLength: 50,
          onChange: "",
          style: "",
          validationRules: [
            { required: true, message: "Dropoff Date Time is required" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const pickup = getFieldValue("pdate");
                if (!value || !pickup) return Promise.resolve();

                if (dayjs(value).isAfter(dayjs(pickup))) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    "Drop-off Date & Time must be later than Pick-up Date & Time.",
                  ),
                );
              },
            }),
          ],
        },
        {
          id: 7,
          label: "Route",
          type: "selectwithvalue",
          name: "route",
          options: filteredRouteList?.map((item) => ({
            value: item.FRouteGUID,
            label: item.FRouteName,
          })),
          placeholder: "High",
          style: "",
          validationRules: [{ required: true, message: "Route is required" }],
        },
      ],
      [
        {
          id: 8,
          label: "Dispatch Type",
          type: "selectwithvalue",
          name: "dispatchtype",
          onChange: handleChange,
          options: DispatchType?.map((item) => ({
            label: item.name,
            value: item.value,
          })),
          disabled: userInfo?.MCID === 3,
          initialValue: userInfo?.MCID === 78 ? "0" : undefined,
          placeholder: "High",
          style: "",
          validationRules: [
            { required: true, message: "Dispatch Type is required" },
          ],
        },
        {
          id: 9,
          label: "Shipment Type",
          type: "selectwithvalue",
          name: "shipmentType",
          onChange: handleChange,
          options:
            userInfo?.MCID === 71
              ? shipmentType
                  ?.filter((item) => item.value === 1)
                  .map((item) => ({
                    label: item.name,
                    value: item.value,
                  }))
              : shipmentType?.map((item) => ({
                  label: item.name,
                  value: item.value,
                })),
          placeholder: "High",
          style: "",
          disabled: userInfo?.MCID === 71, // disable for MCID 71
          validationRules: [
            { required: true, message: "Shipment Type is required" },
          ],
          initialValue:
            userInfo?.MCID === 71 || userInfo?.MCID === 55
              ? 1
              : userInfo?.MCID === 3
                ? 2
                : undefined, // auto-select for MCID 71
        },
        {
          id: 11,
          label: "Finish Type",
          type: "selectwithvalue",
          name: "finishtype",
          onChange: handleChange,
          options:
            userInfo?.MCID === 71
              ? FinishType?.filter((item) => item.value === 5).map((item) => ({
                  label: item.name,
                  value: item.value,
                }))
              : // : userInfo?.MCID === 3
                // ? FinishType?.filter((item) => item.value === 0).map((item) => ({
                //     label: item.name,
                //     value: item.value,
                //   }))
                FinishType?.map((item) => ({
                  label: item.name,
                  value: item.value,
                })),
          filterOption: (input, option) =>
            option?.label?.toLowerCase()?.includes(input.toLowerCase()),
          style: "",
          disabled: userInfo?.MCID === 71, // only MCID 71 is disabled
          validationRules: [
            { required: true, message: "Finish Type is required" },
          ],
          initialValue:
            userInfo?.MCID === 46 || userInfo?.MCID === 55
              ? 5
              : userInfo?.MCID === 78
                ? 1
                : undefined, // only MCID 46 gets auto-selected
        },
        {
          id: 12,
          label: "Reference No",
          type: "text",
          name: "ReferenceNo",
          placeholder: "",
          style: "",
          validationRules: [
            { required: false, message: "Reference No is required" },
          ],
        },
      ],
      [
        // {
        //   id: 6,
        //   label: "Priority",
        //   type: "selectwithvalue",
        //   name: "priority",
        //   options: priorityType?.map((item) => ({
        //     label: item.name,
        //     value: item.value,
        //   })),
        //   placeholder: "High",
        //   style: "",
        //   validationRules: [
        //     { required: true, message: "Priority is required" },
        //   ],
        // },
        {
          id: 12,
          label: "Container No",
          type: "text",
          name: "containerno",
          placeholder: "Container No",
          maxLength: userInfo?.MCID === 78 || userInfo?.MCID === 72 ? 11 : 20,
          style: "",
          validationRules: [
            {
              required: isContainerAccount,
              message: "Container No is required",
            },
            ...(isContainerAccount
              ? [
                  {
                    pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{11}$/,
                    message:
                      "Must be 11 characters with a mix of letters and numbers",
                  },
                ]
              : []),
          ],
        },
        {
          id: 20,
          label: "Vehicle",
          type: "selectwithvalue",
          name: "vehicle",
          options: vehicleOptions,
          onChange: handleSelectChange,
          validationRules: [{ required: true, message: "Vehicle is required" }],
        },
        {
          id: 21,
          label: "Driver",
          type: "selectwithvalue",
          name: "driver",
          placeholder: "Enter Driver",
          options: driverList?.map((item) => ({
            value: item.FULLNM,
            label: item.FULLNM,
          })),
          onChange: handleSelectChange,
          validationRules: [{ required: true, message: "Driver is required" }],
        },
        {
          id: 22,
          label: "Device",
          type: "selectwithvalue",
          name: "device",
          disabled: isDeviceDisabled,
          placeholder: "Enter Device",
          options: deviceOptions,
          onChange: handleSelectChange,
          validationRules: [{ required: true, message: "Device is required" }],
        },
      ],
      [
        {
          id: 22,
          label: "Delivery Note Number",
          type: "text",
          name: "deliveryNo",
          placeholder: "Enter Device",

          validationRules: [
            { required: true, message: "Delivery No is required" },
          ],
        },
        {
          id: 23,
          label: "Remarks",
          type: "text",
          name: "remark",
        },
        {},
        {},
      ],
      [
        // {
        //   id: 3,
        //   label: "Consignee",
        //   type: "addlist",
        //   name: "consignee",
        //   options: consigneeList?.map((item) => ({
        //     label: item.Name,
        //     value: item.ID,
        //   })),
        //   placeholder: "",
        //   style: "",
        //   validationRules: [
        //     { required: true, message: "Consignee is required" },
        //   ],
        // },
        {
          id: 3,
          label: "Consignee",
          type: "addfence",
          name: "fence",
          options: fenceList?.map((item) => ({
            label: item.FName,
            value: item.FGUID,
          })),
          placeholder: "",
          style: "",
          validationRules: [
            { required: true, message: "Consignee is required" },
          ],
        },
        // {
        //   id: 24,
        //   label: "Reference No",
        //   type: "text",
        //   name: "ReferenceNo",
        //   placeholder: "",
        //   style: "",
        //   validationRules: [
        //     { required: false, message: "Reference No is required" },
        //   ],
        // },

        {},
      ],
    ];
    const allFields = [
      ...staticFields,
      ...customFieldRows.filter((row) =>
        row.some((field) => Object.keys(field).length > 0),
      ),
    ];

    return {
      totalpages: 1,
      pages: [
        {
          modalView: false,
          colSpan: [6],
          ...customFieldRows.map((row) => row.map(() => 6)),
          fields: allFields,
        },
      ],
    };
  }, [customFields, formData]);
  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
    { label: "---", value: "---" },
  ];

  const ModalForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [12],
        fields: [
          [
            {
              id: 1,
              label: <span style={{ color: "#5F6D8C" }}>Consign Code</span>,
              type: "text",
              name: "code",
              placeholder: "Enter Consign Code",
              maxLength: 50,
              options: consignerList?.map((item) => ({
                value: item.ID,
              })),
            },
            {
              id: 2,
              label: <span style={{ color: "#5F6D8C" }}>Consignor</span>,
              type: "selectwithvalue",
              name: "consignor",
              placeholder: "GCS",
              maxLength: 50,
              options: consignerList?.map((item) => ({
                label: item.Name,
                value: item.Name,
              })),
            },
            // {
            //   id: 3,
            //   label: <span style={{ color: "#5F6D8C" }}>Transporter</span>,
            //   type: "selectwithvalue",
            //   name: "transporter",
            //   placeholder: "Cargo",
            //   maxLength: 50,
            //   options: transporterList?.map((item) => ({
            //     label: item.Name,
            //     value: item.ID,
            //   })),
            // },
            // {
            //   id: 4,
            //   label: <span style={{ color: "#5F6D8C" }}>Consignee</span>,
            //   type: "selectwithvalue",
            //   name: "consignee",
            //   placeholder: "TQS Agency",
            //   maxLength: 50,
            //   options: consigneeList?.map((item) => ({
            //     label: item.Name,
            //     value: item.ID,
            //   })),
            // },
          ],
          [
            {
              id: 5,
              label: <span style={{ color: "#5F6D8C" }}>Duration</span>,
              type: "selectwithvalue",
              name: "duration",

              placeholder: "Current Month",
              // maxLength: 50,
              options: Duration?.map((item) => ({
                label: item.label,
                value: item.value,
              })),
            },
            {
              id: 6,
              label: <span style={{ color: "#5F6D8C" }}>Date Range</span>,
              type: "daterange",
              name: "daterange",
              placeholder: ["Start Date", "End Date"],
              maxLength: 50,
            },

            {
              id: 7,
              label: (
                <span style={{ color: "#5F6D8C" }}>Consignment Event</span>
              ),
              type: "selectwithvalue",
              name: "event",
              placeholder: "Accepted",
              // maxLength: 50,
              options: EventType?.map((item) => ({
                label: item.name,
                value: item.value,
              })),
            },
            {
              id: 8,
              label: <span style={{ color: "#5F6D8C" }}>Shipment Type</span>,
              type: "selectwithvalue",
              name: "shipment",
              placeholder: "",
              maxLength: 50,
              options: shipmentType?.map((item) => ({
                label: item.name,
                value: item.value,
              })),
            },
            // {
            //   id: 8,
            //   label: <span style={{ color: "#5F6D8C" }}>Priority</span>,
            //   type: "selectwithvalue",
            //   name: "priority",
            //   options: priorityType?.map((item) => ({
            //     label: item.name,
            //     value: item.value,
            //   })),
            //   maxLength: 30,
            // },
          ],
          [
            {
              id: 9,
              label: <span style={{ color: "#5F6D8C" }}>Driver</span>,
              type: "selectwithvalue",
              name: "driver",
              placeholder: "Tony",
              maxLength: 50,
              options: AIVehicleLists?.filter((item) => item?.FDriverName) // only include items with driver name
                .map((item) => ({
                  value: item?.FGUID,
                  label: item?.FDriverName,
                })),
            },
            {
              id: 6,
              label: <span style={{ color: "#5F6D8C" }}>Vehicle</span>,
              type: "selectwithvalue",
              name: "vehicle",
              placeholder: "KA12345",
              options: AIVehicleLists?.map((item) => ({
                value: item?.FGUID,
                label: item?.FVehicleName,
              })),
            },
            {
              id: 7,
              label: <span style={{ color: "#5F6D8C" }}>Town</span>,
              type: "selectwithvalue",
              name: "town",
              placeholder: "Bern",
              maxLength: 50,
              options: Array.isArray(countryList)
                ? countryList.map((item) => ({
                    value: item.NAME,
                  }))
                : [],
            },
            {
              id: 8,
              label: <span style={{ color: "#5F6D8C" }}>Container No</span>,
              type: "text",
              name: "containerno",
              placeholder: "",
              maxLength: 50,
              validationRules: [
                {
                  required: isContainerAccount,
                  message: "Container No is required",
                },
                ...(isContainerAccount
                  ? [
                      {
                        pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{11}$/,
                        message:
                          "Must be 11 characters with a mix of letters and numbers",
                      },
                    ]
                  : []),
              ],
            },
          ],
          [
            {
              id: 9,
              label: <span style={{ color: "#5F6D8C" }}>Reference No</span>,
              type: "text",
              name: "referenceno",
              placeholder: "",
              maxLength: 50,
            },
            {},
          ],
        ],
      },
    ],
  };
  // const handleUpload = async (file) => {
  //   const formData = new FormData();
  //   formData.append("file", file); // 'file' is the key your backend will expect

  //   try {
  //     setLoading(true);
  //     const response = await axios.post(
  //       "https://ks5jby85id.execute-api.us-east-2.amazonaws.com/Prod/consignments/import",
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );

  //     if (response.status === 200) {
  //       message.success("CSV imported successfully!");
  //       getAssignedConsignments();
  //       setLoading(false);
  //     } else {
  //       message.error("Failed to import CSV.");
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     console.error("Upload error:", error);
  //     message.error("Something went wrong during upload.");
  //   }

  //   return false; // Prevent default upload behavior
  // };

  // Debugging: Log updated formData
  useEffect(() => {
    getAssignedConsignments();
    const count = Object?.values(filterData)?.filter(
      (val) => val && val.length !== 0,
    )?.length;

    setFilterCount(count);
  }, [filterData, currentPage, pageSize, activeTab]);

  useEffect(() => {
    if (customFields.length && selectedCustomColumns.length === 0) {
      setSelectedCustomColumns(customFields.map((f) => f.CFID));
    }
  }, [customFields]);
  useEffect(() => {
    const fetchAllCustomFields = async () => {
      setLoading(true);
      try {
        const [dataAIBulkcreate] = await Promise.all([
          CALL_API("POST", `mastertable/GetByReftab`, {
            ReftableId: "AIBulkcreate",
            RefId: 0,
            Active: 1,
            McId: userInfo?.MCID,
          }),
        ]);
        // Merge and deduplicate by CFID
        const allFields = [
          // ...(Array.isArray(dataAICONSIGN?.data) ? dataAICONSIGN.data : []),
          ...(Array.isArray(dataAIBulkcreate?.data)
            ? dataAIBulkcreate.data
            : []),
        ];
        // Only set empty if both are truly empty
        if (allFields.length === 0) {
          setCustomFields([]);
        } else {
          const uniqueFields = Object.values(
            allFields.reduce((acc, field) => {
              acc[field.CFID] = field;
              return acc;
            }, {}),
          );
          setCustomFields(uniqueFields);
        }
      } catch (error) {
        // Only clear if both failed
        setCustomFields([]);
        console.error("Error fetching custom fields:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllCustomFields();
    // GetAllCustomeData("AICONSIGN");
    GetAllCustomeData("AIBulkcreate");
  }, []);
  //create consign form
  const BulkCreateForm = useMemo(() => {
    const mappedCustomFields = customFields?.map((field) => {
      const name = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
      const type = getFieldType(field.FIELDTYPE);
      let options;

      // For dropdowns, parse options from DATASOURCE or OPTIONS
      if (type === "selectwithvalue" && (field.DATASOURCE || field.OPTIONS)) {
        const source = field.DATASOURCE || field.OPTIONS;
        options = source
          .split(",")
          .map((opt) => ({
            label: opt.trim(),
            value: opt.trim(),
          }))
          .filter((opt) => opt.value); // Remove empty options
      }

      return {
        id: field.CFID,
        label: field.FIELDNAME,
        type,
        name,
        placeholder: field.FIELDNAME,
        maxLength: field.MAXLEN > 0 ? field.MAXLEN : undefined,
        validationRules: field.REQUIRED
          ? [{ required: true, message: `${field.FIELDNAME} is required` }]
          : [],
        value: formData[name],
        onChange: handleChange,
        ...(options ? { options } : {}),
      };
    });
    const customFieldRows = chunkArray(mappedCustomFields || [], 3);

    const staticFields = [
      [
        {
          id: 1,
          label: "Consignor",
          type: "selectwithvalue",
          name: "consignor",
          options:
            userInfo?.MCID === 71
              ? consignerList
                  ?.filter((item) => item.ID === 14045)
                  .map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))
              : userInfo?.MCID === 46
                ? consignerList
                    ?.filter((item) => item.ID === 32921)
                    .map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))
                : consignerList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  })),
          placeholder: "Consignor",
          style: "",
          disabled: userInfo?.MCID === 71 || userInfo?.MCID === 46,
          validationRules: [
            { required: true, message: "Consignor is required" },
          ],
          initialValue:
            userInfo?.MCID === 71
              ? 14045
              : userInfo?.MCID === 46
                ? 32921
                : undefined,
        },
        {
          id: 2,
          label: "Transporter",
          type: "selectwithvalue",
          name: "transporter",
          options:
            userInfo?.MCID === 71
              ? transporterList
                  ?.filter((item) => item.ID === 14046)
                  .map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))
              : userInfo?.MCID === 46
                ? transporterList
                    ?.filter((item) => item.ID === 32922)
                    .map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))
                : transporterList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  })),
          placeholder: "Transporter",
          style: "",
          disabled: userInfo?.MCID === 71 || userInfo?.MCID === 46,
          validationRules: [
            { required: true, message: "Transporter is required" },
          ],
          initialValue:
            userInfo?.MCID === 71
              ? 14046
              : userInfo?.MCID === 46
                ? 32922
                : userInfo?.MCID === 78
                  ? 2
                  : undefined,
        },

        // {
        //   id: 3,
        //   label: "Consignee",
        //   type: "selectwithvalue",
        //   name: "consignee",
        //   options: consigneeList?.map((item) => ({
        //     label: item.Name,
        //     value: item.ID,
        //   })),
        //   placeholder: "TQS Agency",
        //   style: "",
        //   validationRules: [
        //     { required: true, message: "Consignee is required" },
        //   ],
        // },
        {
          id: 3,
          label: "Consignee",
          type: "selectwithvalue",
          name: "fence",
          options: fenceList?.map((item) => ({
            label: item.FName,
            value: item.FGUID,
          })),
          placeholder: "TQS Agency",
          style: "",
          validationRules: [
            { required: true, message: "Consignee is required" },
          ],
        },
        {
          id: 4,
          label: "Charge Type",
          type: "selectwithvalue",
          name: "chargetype",
          options:
            userInfo?.MCID === 46
              ? chargetype
                  ?.filter((item) => item.value === 6)
                  .map((item) => ({
                    label: item.name,
                    value: item.value,
                  }))
              : userInfo?.MCID === 72
                ? chargetype
                    ?.filter((item) => item.value === 3)
                    .map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))
                : chargetype?.map((item) => ({
                    label: item.name,
                    value: item.value,
                  })),
          disabled: userInfo?.MCID === 46 || userInfo?.MCID === 72,
          style: "",
          validationRules: [
            { required: true, message: "Charge Type is required" },
          ],
          initialValue:
            userInfo?.MCID === 46 ? 6 : userInfo?.MCID === 78 ? 3 : undefined,
        },
      ],

      [
        // {
        //   id: 5,
        //   label: "Priority",
        //   type: "selectwithvalue",
        //   name: "priority",
        //   options: priorityType?.map((item) => ({
        //     label: item.name,
        //     value: item.value,
        //   })),
        //   placeholder: "High",
        //   style: "",
        //   validationRules: [
        //     { required: true, message: "Priority is required" },
        //   ],
        // },
        {
          id: 6,
          label: "Number of Deliverables",
          type: "number",
          name: "noofdeliverables",
          placeholder: "200",
          style: "",
          validationRules: [
            { required: false, message: "Number of Deliverables is required" },
          ],
        },
        {
          id: 7,
          label: (
            <span
              style={{
                color: "black",
                fontSize:
                  window.innerWidth >= 320 && window.innerWidth <= 480
                    ? "12px"
                    : "14px",
              }}
            >
              {window.innerWidth >= 320 && window.innerWidth <= 480
                ? "Single Deliverable (in cm)"
                : "Dimension of single deliverable (in cm)"}
            </span>
          ),
          type: "text",
          name: "dimension",
          placeholder: "200",
          style: "",
          validationRules: [
            {
              required: false,
              message: "Dimension of single deliverable is required",
            },
          ],
        },
        {
          id: 8,
          label: "Gross Weight (in Kg)",
          type: "text",
          name: "gross",
          placeholder: "200",
          style: "",
        },
      ],
      [
        {
          id: 9,
          label: "Delivery Pin",
          type: "switch",
          name: "switch",
        },
        {
          id: 10,

          label:
            window.innerWidth >= 320 && window.innerWidth <= 480
              ? "Pickup Date & Time"
              : "Pickup Date & Time",
          type: "date",
          showtime: true,
          format: "YYYY-MM-DD HH:mm:ss",
          name: "pdate",
          placeholder: "24th Aug 2024; 07:10 AM",
          value: "formData.pdate",
          maxLength: 50,
          onChange: "",
          style: "",
          validationRules: [
            { required: true, message: "Pickup Date & Time is required" },
          ],
        },
        {
          id: 11,
          label: "Dropoff Date & Time",
          type: "date",
          name: "ddate",
          showtime: true,
          format: "YYYY-MM-DD HH:mm:ss",
          placeholder: "24th Aug 2024; 07:10 AM",
          value: "formData.ddate",
          maxLength: 50,
          onChange: "",
          style: "",
          validationRules: [
            { required: true, message: "Dropoff Date Time is required" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const pickup = getFieldValue("pdate");
                if (!value || !pickup) return Promise.resolve();

                if (dayjs(value).isAfter(dayjs(pickup))) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    "Drop-off Date & Time must be later than Pick-up Date & Time.",
                  ),
                );
              },
            }),
          ],
        },
        {},
      ],
      // [
      //   {
      //     id: 13,
      //     label: "Dispatch Type",
      //     type: "selectwithvalue",
      //     name: "dispatchtype",
      //     options: DispatchType?.map((item) => ({
      //       label: item?.name,
      //       value: item?.value,
      //     })),
      //     placeholder: "Regular",
      //     style: "",
      //     validationRules: [
      //       { required: true, message: "Dispatch Type is required" },
      //     ],
      //   },
      //   {
      //     id: 14,
      //     label: "Shippment Type",
      //     type: "selectwithvalue",
      //     name: "shipmenttype",
      //     options: shipmentType?.map((item) => ({
      //       label: item?.name,
      //       value: item?.value,
      //     })),
      //     placeholder: "Delivery",
      //     style: "",
      //     validationRules: [
      //       { required: true, message: "ShipmentType Type is required" },
      //     ],
      //   },
      //   {
      //     id: 15,
      //     label: "Finished Type",
      //     type: "selectwithvalue",
      //     name: "finishtype",
      //     options: FinishType?.map((item) => ({
      //       label: item.name,
      //       value: item.value,
      //     })),
      //     placeholder: "Select Finished Type",
      //     style: {},
      //     validationRules: [
      //       { required: true, message: "Finished Type is required" },
      //     ],
      //   },
      //   {
      //     id: 16,
      //     label: "Delivery No",
      //     type: "text",
      //     name: "deliveryno",
      //     placeholder: "",
      //     style: "",
      //     validationRules: [
      //       { required: true, message: "Delivery Number is required" },
      //     ],
      //   },
      // ],
      [
        {
          id: 13,
          label: "Pickup Notes",
          type: "text",
          name: "pickupnotes",
          placeholder: "",
          style: "",
          validationRules: [
            { required: false, message: "Priority is required" },
          ],
        },
        {
          id: 14,
          label: "Dropoff Notes",
          type: "text",
          name: "dropoffnotes",
          placeholder: "",
          style: "",
          validationRules: [
            { required: false, message: "Dropoff Notes is required" },
          ],
        },
        {
          id: 15,
          label: "Remarks",
          type: "text",
          name: "remark",
          placeholder: "",
          style: "",
          validationRules: [
            { required: false, message: "Remarks is required" },
          ],
        },
        {
          id: 16,
          label: "Zone",
          type: "text",
          name: "Zone",
          placeholder: "",
          style: "",
          validationRules: [{ required: false, message: "Zone is required" }],
        },
      ],
      [
        {
          id: 17,
          label: "Link Dossier",
          type: "text",
          name: "linkdossier",
          placeholder: "",
          style: "",
          validationRules: [
            { required: false, message: "Link Dossier is required" },
          ],
        },
        {
          id: 18,
          label: "Reference No",
          type: "text",
          name: "ReferenceNo",
          placeholder: "",
          style: "",
          validationRules: [
            { required: false, message: "Reference No is required" },
          ],
        },
        {
          id: 19,
          label: "Container No",
          type: "text",
          name: "containerno",
          maxLength: 11,
          validationRules: [
            {
              required:
                userInfo?.MCID === 78 || userInfo?.MCID === 72 ? true : false,
              message: "Container No is required",
            },
            {
              pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{11}$/,
              message:
                "Must be 11 characters with a mix of letters and numbers",
            },
          ],
        },
        //       {
        //   id: 20,
        //   label: "Reference No",
        //   type: "text",
        //   name: "ReferenceNo",
        //   placeholder: "",
        //   style: "",
        //   validationRules: [
        //     { required: false, message: "Reference No is required" },
        //   ],
        // },
      ],
    ];
    const allFields = [
      ...staticFields,
      ...customFieldRows.filter((row) =>
        row.some((field) => Object.keys(field).length > 0),
      ),
    ];

    return {
      totalpages: 1,
      pages: [
        {
          modalView: false,
          colSpan: [6],
          ...customFieldRows.map((row) => row.map(() => 6)),
          fields: allFields,
        },
      ],
    };
  }, [customFields, formData]);

  const AssignModal = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [24],
        fields: [
          [
            {
              id: 1,
              label: <span style={{ color: "#5F6D8C" }}>Vehicle-Driver</span>,
              type: "select",
              name: "driver",
              placeholder: "KA2313- Dev Edward",
              maxLength: 50,
            },
            {
              id: 2,
              label: <span style={{ color: "#5F6D8C" }}>Trip Code</span>,
              type: "select",
              name: "tripcode",
              placeholder: "9123",
              maxLength: 50,
            },
          ],
        ],
      },
    ],
  };

  const locationClick = (name) => {
    setSelectedItem(name);
    setLocationModal(true);
  };

  const handleclick = (record) => {
    setConsignee(true);
    setConsignmentDetails(record);
  };

  const handleDelete = async (id) => {
    setLoading(true);
    const { data } = await CALL_API(
      "Delete",
      `ai/consignment/delete_consignment/${id}`,
    );

    await CustomeDataDelete(reftab, id);
    setConsignee(false);
    getAssignedConsignments();

    setLoading(false);
    message.success("Consignment Deleted Successfully");
  };

  const handleBulkDelete = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `ai/bulkDeleteAIConsignment`, {
      consignIds: selectedRowKeys,
    });

    for (const id of selectedRowKeys) {
      await CustomeDataDelete(reftab, id);
    }
    setConsignee(false);
    GetAllCustomeData(reftab);
    getAssignedConsignments();
    setIsBulkDeleteModalVisible(false);

    setLoading(false);
    message.success("Consignments Deleted Successfully");
  };

  const getsingleConsigneeData = async (id) => {
    try {
      const { data } = await CALL_API("GET", `entity/getbyId?id=${id}`);
      return data;
    } catch (error) {
      console.error("Error fetching consignee data:", error);
      return null;
    }
  };
  //Bulk create API Calling Function
  const bulkSubmit = async (values) => {
    setLoading(true);
    const selectedVehicle = vehicleOptions.find(
      (v) => String(v.value) === String(values.vehicle),
    );
    const vehRegNo = selectedVehicle?.label || "";
    const vehTypeId = selectedVehicle?.vehicleTypeId || null;
    const Drivername = values.driver || selectedVehicle?.DriverName || "";
    if (!vehRegNo || !vehTypeId) {
      message.error("Please select a valid vehicle.");
      setLoading(false);
      return;
    }
    const deviceName =
      deviceOptions.find((d) => String(d.value) === String(values.device))
        ?.label || "";

    const routeName =
      routeOptions.find((r) => String(r.value) === String(values.route))
        ?.label || "";

    const companyName =
      companyOptions.find((c) => String(c.value) === String(values.company))
        ?.label || "";

    const dispatchTypeName =
      DispatchType?.find((item) => item.value === formData?.dispatchtype)
        ?.name || "";
    const FDeviceGUID =
      filteredDeviceList?.find((d) => d.FAssetID === values.device)?.FGUID ||
      "";

    try {
      const fenceArray = Array.isArray(formData.fence)
        ? formData.fence
        : formData.fence
          ? [formData.fence]
          : [];
      const cleanFenceArray = fenceArray.map((f) => Object.values(f)[0]);
      // Prepare Consignments array
      const consigneeData = await Promise.all(
        cleanFenceArray.map(async (fenceFGUID, idx) => {
          const selectedFence = fenceList.find(
            (f) => String(f.FGUID) === String(fenceFGUID),
          );
          // const consigneeId = Object.values(item)[0];
          // const data = await getsingleConsigneeData(consigneeId);
          return {
            Cust: formData?.consignor, // or ConsignorID if available
            Shipper: formData?.transporter, // or TransporterId if available
            Receiver: null,
            FID: fenceFGUID,
            FName: selectedFence?.FName || "",
            StartLocation: formData?.plocationname?.place_name,
            StartLat: Number(formData?.plocationname?.latitude),
            StartLng: Number(formData?.plocationname?.longitude),
            EndLocation: selectedFence?.FName || "",
            EndLat: Number(selectedFence?.FCenterLat) || 0,
            EndLng: Number(selectedFence?.FCenterLon) || 0,
            GrossWeight: Number(formData?.gross) || 0,
            GrossVolume: Number(formData?.gross) || 0,
            PickUpDateTime: formData?.pdate
              ? dayjs(formData.pdate).toISOString()
              : undefined,
            DropOffDateTime: formData?.ddate
              ? dayjs(formData.ddate).toISOString()
              : undefined,
            ChargeType: formData?.chargetype,
            PickUpNote: formData?.pickupnotes || "",
            DropOffNote: formData?.dropoffnotes || "",
            Remarks: formData?.remark,
            Priority: 1,
            ISDELOTP: formData?.switch,
          };
        }),
      );

      // Build the main payload
      const payload = {
        Company: userInfo?.MCID === 59 ? companyName : userInfo?.COMPNAME || "",
        VehId: values.vehicle, // Set from vehicle selection if available
        VehRegNo: vehRegNo, // Set from vehicle selection if available
        VTypeId: vehTypeId, // Set from vehicle selection if available
        DriverName: Drivername, // Set from vehicle selection if available
        TripType: formData?.tripType,
        ShipmentTypeId: formData?.shipmentType,
        FinishType: formData?.finishtype,
        userId: userInfo?.UID,
        Remarks: formData?.remark,
        DispatchType: formData?.dispatchtype, // Add this field
        DispatchTypeID: formData?.dispatchtype.toString(), // Add this field
        DeliveryNotesNo: formData?.dnotes,
        TripAllowance: formData?.tripallowance || 0,
        FuelQuantity: Number(formData?.fuelQuantity) || 0,
        ConsignorID: formData?.consignor.toString, // or the correct field
        ConsignorName: formData?.consignor,
        TransporterId: Number(formData?.transporter) || 0,
        PickupDateTime: formData?.pdate
          ? dayjs(formData.pdate).toISOString()
          : undefined,
        DropOffDateTime: formData?.ddate
          ? dayjs(formData.ddate).toISOString()
          : undefined,
        ConsigneeID: formData?.consignee?.[0]?.value || 0,
        // ConsigneeID: Number(formData?.consignee) || 0,
        DeviceID: FDeviceGUID,
        DeviceName: values.device,
        DeliveryNotesNo: formData?.deliveryNo,
        Priority: 1,
        RouteID: values.route,
        RouteName: routeName,
        DispatchTypeName: dispatchTypeName,
        ShipmentTypeId: formData?.shipmentType,
        FinishType: formData?.finishtype,
        McId: userInfo?.MCID,
        FWayBill: formData?.deliveryNo,
        ReferenceNo: formData?.ReferenceNo,
        ContainerNo: formData?.containerno,
        Consignments: consigneeData,
      };
      const { data, ResponseCode } = await CALL_API(
        "POST",
        `ai/consignment/createbulk`,
        payload,
      );

      if (ResponseCode === 200 && Array.isArray(data?.ConsignmentIds)) {
        for (const ConsignId of data.ConsignmentIds) {
          if (ConsignId) {
            await CustomeDataCreate(reftab, ConsignId, values);
          }
        }

        message.success("Consignment created successfully");
        handleCancel();
        getAssignedConsignments();
        setDrawerOpen(false);
      } else {
        // Handle vehicle already on active trip
        if (
          typeof data === "string" &&
          data.toLowerCase().includes("fassetid")
        ) {
          message.error(
            "This vehicle has an ongoing trip that needs to be completed.",
          );
        } else {
          // Fallback for other errors
          message.error(
            typeof data === "string"
              ? data
              : "Failed to create consignment. Please try again.",
          );
        }
      }
    } catch (error) {
      console.error("[bulkSubmit] Error -->", error);
      message.error("Error occurred while creating consignment");
    } finally {
      setLoading(false);
    }
  };
  //Consignment Create and Update API CALLING function
  const handleSubmitForm = async (values) => {
    try {
      setLoading(true);

      // Defensive: get first consignee ID if array
      const receiverId = Array.isArray(formData?.consignee)
        ? formData.consignee[0]?.value || formData.consignee[0]
        : formData?.consignee;
      const selectedFence = fenceList.find(
        (f) =>
          String(f.FGUID) === String(formData?.fence) ||
          String(f.FName) === String(formData?.fence),
      );
      const payload = {
        ChargeType: formData?.chargetype,
        Cust: formData?.consignor,
        DropOffDateTime: formData?.ddate
          ? dayjs(formData.ddate).toISOString()
          : undefined,
        DropOffNote: formData?.dropoffnotes || "",
        // EndLocation: formData?.dlocation || "",
        GrossVolume: Number(formData?.gross) || 0,
        GrossWeight: Number(formData?.gross) || 0,
        ISDELOTP: formData?.switch,
        PickUpDateTime: formData?.pdate
          ? dayjs(formData.pdate).toISOString()
          : undefined,
        PickUpNote: formData?.pickupnotes,
        Priority: 1,
        Receiver: null,
        FID: formData?.fence || selectedFence?.FGUID,
        FName: selectedFence?.FName,
        Remarks: formData?.remark,
        Shipper: formData?.transporter,
        StartLat: Number(
          formData?.plocationname?.latitude ?? formData?.StartLat,
        ),
        StartLng: Number(
          formData?.plocationname?.longitude ?? formData?.StartLng,
        ),
        // EndLat: Number(
        //   formData?.dlocationname?.latitude ?? formData?.EndLat
        // ),
        // EndLng: Number(
        //   formData?.dlocationname?.longitude ?? formData?.EndLng
        // ),
        EndLocation: selectedFence?.FAddress || "",
        EndLat: Number(selectedFence?.FCenterLat) || 0,
        EndLng: Number(selectedFence?.FCenterLon) || 0,
        StartLocation: formData?.plocationname?.place_name,
        McId: userInfo?.MCID,
        dimension: formData?.dimension || "",
        noOfDeliverables: formData?.noofdeliverables || 0,
        FWayBill: formData?.deliveryNo || "",
        ReferenceNo: formData?.ReferenceNo,
        ContainerNo: formData?.containerno,
        TripId: isEdit ? formData?.TripId : null,
        CrBy: isEdit ? formData?.CrBy : userInfo?.UID,
        ConsignId: isEdit ? formData?.ConsignId : undefined,
      };

      const { data } = await CALL_API(
        isEdit ? "PATCH" : "POST",
        isEdit ? `ai/consignment/update_consignment` : `ai/consignment/create`,
        payload,
      );

      const ConsignId = isEdit
        ? formData?.ConsignId
        : data?.ConsignId || data?.CONSIGNID || data?.result?.CONSIGNID;

      if (ConsignId) {
        if (!isEdit) {
          await CustomeDataCreate(reftab, ConsignId, values);
        } else {
          await CustomeDataUpdate(reftab, ConsignId, values);
        }
      } else {
        console.error("ConsignId not found in API response:", data);
      }
      await GetAllCustomeData(reftab);
      await getAssignedConsignments();
      handleCancel();
      message.success(
        isEdit
          ? "Consignment updated successfully"
          : "Consignment created successfully",
      );
      setLoading(false);
      setIsDeviceDisabled(true);
    } catch (error) {
      console.error("[handleSubmitForm] error -->", error);
      setLoading(false);
    }
  };

  const [checkedList, setCheckedList] = useState([]);

  const onCheckAllChange = async (e) => {
    const isChecked = e.target.checked;
    setSortFields(isChecked ? allOptions : []);
    setSortColumns(
      isChecked ? allOptions.map((col) => ({ column: col, order: "ASC" })) : [],
    );
  };

  const allOptions = [
    "SupName",
    "Code",
    "CustName",
    "FNAME",
    "ReferenceNo",
    "FWayBill",
    "ContainerNO",
  ];

  const sortOptionLabels = [
    { value: "FNAME", label: "Consignee" },
    { value: "CustName", label: "Consignor" },
    { value: "SupName", label: "Transporter" },
    { value: "Code", label: "Order No" },
    { value: "ContainerNO", label: "Container Number" },
    { value: "ReferenceNo", label: "Reference No" },
    { value: "FWayBill", label: "Delivery Note Number" },
  ];

  const handleSortOptionsChange = async (checkedValues) => {
    setSortFields(checkedValues);
    setSortColumns((prev) => {
      const kept = prev.filter((sc) => checkedValues.includes(sc.column));
      const added = checkedValues
        .filter((col) => !prev.find((sc) => sc.column === col))
        .map((col) => ({ column: col, order: "ASC" }));
      return [...kept, ...added];
    });
  };

  const toggleSortOrder = (column) => {
    setSortColumns((prev) =>
      prev.map((sc) =>
        sc.column === column
          ? { ...sc, order: sc.order === "ASC" ? "DESC" : "ASC" }
          : sc,
      ),
    );
  };

  useEffect(() => {
    if (sortColumns.length > 0) {
      getAssignedConsignments();
    }
  }, [sortColumns]);

  const content = (
    <WrapperBox>
      <div className="checkbox_group_container">
        <div class="d-flex align-items-center justify-content-between border-bottom pb-2 ">
          <Checkbox
            // indeterminate={
            //   sortFields.length > 0 && sortFields.length < allOptions.length
            // }
            onChange={onCheckAllChange}
            checked={sortFields.length === allOptions.length}
          >
            All
          </Checkbox>
          {sortFields.length > 0 && (
            <Button
              style={{ color: "#28a745", border: "0px" }}
              onClick={() => {
                setSortColumns([]);
                setSortFields([]);
              }}
            >
              Reset
            </Button>
          )}
        </div>

        <Checkbox.Group value={sortFields} onChange={handleSortOptionsChange}>
          <div className="checkbox_group_container">
            {sortOptionLabels.map(({ value, label }) => (
              <div
                key={value}
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <Checkbox value={value}>{label}</Checkbox>
                {sortFields.includes(value) && (
                  <span
                    onClick={() => toggleSortOrder(value)}
                    style={{
                      cursor: "pointer",
                      fontSize: "11px",
                      color: "#2C963D",
                      fontWeight: 600,
                      border: "1px solid #2C963D",
                      borderRadius: "4px",
                      padding: "1px 5px",
                      userSelect: "none",
                    }}
                  >
                    {sortColumns.find((sc) => sc.column === value)?.order ??
                      "ASC"}
                  </span>
                )}
              </div>
            ))}
          </div>
        </Checkbox.Group>
      </div>
    </WrapperBox>
  );
  const handleCopyClick = async () => {
    setNewLoading(true);
    try {
      const { data, ResponseCode } = await CALL_API(
        "POST",
        "aiconsignment/copy",
        {
          consignId: copyId,
          MCID: userInfo?.MCID,
        },
      );
      if (ResponseCode !== 200) {
        message.error("Something went wrong. Please try again later!");
      } else {
        message.success("Consignment duplicated successfully");
      }
      setIsConformationModal(false);
      setCopyId(null);
      getAssignedConsignments();
      setNewLoading(false);
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };
  const [width, setWidth] = useState(window.innerWidth);
  const [status, setStatus] = useState("Assigned");
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleChangeformobile = (value) => {
    setStatus(value);

    if (value === "Assigned") {
      setActiveTab("label1");
    } else if (value === "Unassigned") {
      setActiveTab("label2");
    }
  };

  const [widdth, setWiddth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWiddth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <UIModal
        width={1200}
        open={showModal}
        onClose={handlecancelmodal}
        closeButton={false}
        size="lg"
        header={
          <WrapperBox>
            <Row>
              <Col xl={24} sm={24}>
                <div className="modal_container_forfiltermenu">
                  <span className="flilter_five">Filters ({filterCount})</span>
                  {/* <span
                     style={{
                       color: "#2C963D",
                       fontWeight: "400",
                       fontSize: "20px",
                     }}
                   >
                     5 Results Found
                   </span> */}
                </div>
              </Col>
            </Row>
          </WrapperBox>
        }
        footer={
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <ButtonFilled onClick={editModuleupdate}>Clear All</ButtonFilled>
          </div>
        }
      >
        {/* This is the BODY section of the Modal */}
        <WrapperBox>
          <GridBuilder
            formStructureJson={ModalForm}
            handleChange={handleFilterChange}
            formSubmit={handleSubmitForm}
            initialValues={filterData}
            handleSelectChange={handleFilterSelectChange}
            form={filterform}
            twoPerRowInMobile={true} // <-- this enables 2 fields per row in mobile
          />
        </WrapperBox>
      </UIModal>
      <UIModal
        width={700}
        open={isConformationModal}
        onClose={() => {
          setIsConformationModal(false);
          setCopyId(null);
        }}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>You want to duplicate this consignment?</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled loading={newLoading} onClick={handleCopyClick}>
              Yes
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsConformationModal(false);
                setCopyId(null);
              }}
            >
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <UIModal
        width={500}
        open={isDeleteModalVisible}
        onClose={() => {
          setIsDeleteModalVisible(false);
          setDeleteId(null); // Reset the delete ID
        }}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>"You want to delete this consignment?"</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              onClick={() => {
                handleDelete(deleteId); // Call the delete function with the selected ID
                setIsDeleteModalVisible(false); // Close the modal
                setDeleteId(null); // Reset the delete ID
              }}
            >
              Yes
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsDeleteModalVisible(false); // Close the modal
                setDeleteId(null); // Reset the delete ID
              }}
            >
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>

      {consignee ? (
        <>
          <Consignordetails1
            // consignmentDetails={consignmentDetails}
            assignedConsignments={assignedConsignments}
            setDrawerOpen={setDrawerOpen}
            setConsignee={setConsignee}
            AddEditFormm={AddEditFormm}
            handleChange={handleChange}
            handleSubmitForm={handleSubmitForm}
            handleClose={handleClose}
            drawerOpen={drawerOpen}
            formData={formData}
            WrapperBox={WrapperBox}
            consignmentDetails={consignmentDetails}
            activeTab={activeTab}
            setFormData={setFormData}
            setIsEdit={setIsEdit}
            form={form}
            handleDelete={handleDelete}
            getAssignedConsignments={getAssignedConsignments}
          />
        </>
      ) : (
        <>
          <WrapperBox>
            <Row gutter={16}>
              <Col xs={24} xl={24}>
                <Row gutter={16}>
                  <Col xs={24} xl={24}>
                    <div className="container_for_assigned_unassigned">
                      <div>
                        {width >= 320 && width <= 480 ? (
                          <div className="mobile_section">
                            <Select
                              className="selectdropdown_responsive"
                              value={status}
                              onChange={(value) => handleChangeformobile(value)}
                              style={{
                                width: 250,
                                borderRadius: 8,
                              }}
                              dropdownStyle={{
                                backgroundColor: "white",
                                borderRadius: 8,
                                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                              }}
                              bordered={false}
                              popupClassName="custom-dropdown"
                            >
                              <Option value="Assigned">Assigned</Option>
                              <Option value="Unassigned">Unassigned</Option>
                            </Select>
                          </div>
                        ) : (
                          <div></div>
                        )}

                        {width >= 320 && width <= 480 ? null : (
                          <Tab
                            defaultActiveKey={activeTab}
                            items={[
                              { key: "label1", label: "Assigned" },
                              { key: "label2", label: "Unassigned" },
                            ]}
                            onChange={handleTabChange}
                          />
                        )}
                      </div>
                      <div>
                        <div className="consingment_container">
                          <div className="consingment_container_two  responsive_containerone">
                            {width >= 320 && width <= 480 ? null : (
                              <>
                                <div className="Custom">
                                  <Tooltip
                                    title="Export"
                                    placement="bottom"
                                    visible={visibleExport}
                                    onVisibleChange={
                                      handleTooltipVisibleChangeExport
                                    }
                                    overlayInnerStyle={{
                                      backgroundColor: "transparent",
                                      color: "#5f6d8c",
                                      boxShadow: "none",
                                      padding: "0",
                                    }}
                                  >
                                    <Spin spinning={CSVLoader}>
                                      <img
                                        src={ExportIcon}
                                        alt="Export"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          cursor: exportAllowed
                                            ? "pointer"
                                            : "not-allowed",
                                          marginRight: "40px",
                                          backgroundColor: "#EBF7ED",
                                          borderRadius: "6px",
                                        }}
                                        onClick={() => {
                                          if (!exportAllowed) return;
                                          prepareCSV();
                                        }}
                                      />
                                    </Spin>
                                    <CSVLink
                                      data={CSVList}
                                      filename={"Consignment.csv"}
                                      asyncOnClick={true}
                                      ref={csvLinkEl}
                                    />
                                  </Tooltip>
                                </div>
                              </>
                            )}
                            {width >= 320 && width <= 480 ? null : (
                              <div className="Custom">
                                <Tooltip
                                  title={
                                    !importAllowed ? "No permission" : "Import"
                                  }
                                  placement="bottom"
                                  visible={visibleImport}
                                  onVisibleChange={
                                    handleTooltipVisibleChangeImport
                                  }
                                  overlayInnerStyle={{
                                    backgroundColor: "transparent",
                                    color: "#5f6d8c",
                                    boxShadow: "none",
                                    padding: "0",
                                  }}
                                >
                                  {/* <Upload
                                  onClick={() => setImportOpen(true)}
                                    // beforeUpload={handleUpload}
                                    showUploadList={false}
                                    accept=".csv"
                                  > */}
                                  <img
                                    onClick={() => setImportOpen(true)}
                                    src={ImportIcon}
                                    alt="Import"
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      cursor: importAllowed
                                        ? "pointer"
                                        : "not-allowed",
                                      marginRight: "40px",
                                      backgroundColor: "#EBF7ED",
                                      borderRadius: "6px",
                                    }}
                                  />
                                  {/* </Upload> */}
                                </Tooltip>
                              </div>
                            )}
                            <Badge
                              count={filterCount}
                              className="badg"
                              style={{ marginRight: "20px" }}
                            >
                              <Avatar
                                shape="circle"
                                size="small"
                                src={FilterIcon}
                                className="filterstyle"
                                onClick={handleclickme}
                                style={{ marginRight: "20px" }}
                              />
                            </Badge>
                            {width >= 320 && width <= 480 ? null : (
                              <div className="Custom">
                                <Tooltip
                                  title="Sort Column"
                                  placement="bottom"
                                  visible={visibleSort}
                                  onVisibleChange={
                                    handleTooltipVisibleChangeSort
                                  }
                                  overlayInnerStyle={{
                                    backgroundColor: "transparent",
                                    color: "#5f6d8c",
                                    boxShadow: "none",
                                    padding: "0",
                                  }}
                                >
                                  <Popover content={content} trigger="click">
                                    <img
                                      src={SortIcon}
                                      alt="Sort"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        cursor: "pointer",
                                        marginRight: "30px",
                                        backgroundColor: "#EBF7ED",
                                        borderRadius: "6px",
                                      }}
                                      onClick={(e) => e.preventDefault()}
                                    />
                                  </Popover>
                                </Tooltip>
                              </div>
                            )}
                            <ButtonOutlined
                              onClick={() => setIsconfigModalVisible(true)}
                              className="Create_btn"
                            >
                              Configure
                            </ButtonOutlined>
                            <Tooltip
                              title={!createAllowed ? "No permission" : ""}
                            >
                              <ButtonOutlined
                                style={{
                                  cursor: createAllowed
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                                onClick={() => {
                                  if (!createAllowed) return;
                                  handleCreateClick();
                                }}
                                className="Create_btn"
                              >
                                + Create
                              </ButtonOutlined>
                            </Tooltip>
                            <Tooltip
                              title={!createAllowed ? "No permission" : ""}
                            >
                              <ButtonOutlined
                                style={{
                                  cursor: createAllowed
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                                onClick={() => {
                                  if (!createAllowed) return;
                                  handleBulkCreateClick();
                                }}
                                className="bulk_btn"
                              >
                                + Bulk Create
                              </ButtonOutlined>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} xl={24}>
                <div className="consingment_container">
                  {/* <p className="datsource_length">{total} Consignments</p> */}
                  {/* <div className="consingment_container_two">
                     <div className="Custom">
                       <Tooltip
                         title="Export"
                         placement="bottom"
                         visible={visibleExport}
                         onVisibleChange={handleTooltipVisibleChangeExport}
                         overlayInnerStyle={{
                           backgroundColor: "transparent",
                           color: "#5f6d8c",
                           boxShadow: "none",
                           padding: "0",
                         }}
                       >
                         <img
                           src={ExportIcon}
                           alt="Export"
                           style={{
                             width: "20px",
                             height: "20px",
                             cursor: "pointer",
                             marginRight: "40px",
                             backgroundColor: "#EBF7ED",
                             borderRadius: "6px",
                           }}
                         />
                       </Tooltip>
                     </div>
                     <div className="Custom">
                       <Tooltip
                         title="Import"
                         placement="bottom"
                         visible={visibleImport}
                         onVisibleChange={handleTooltipVisibleChangeImport}
                         overlayInnerStyle={{
                           backgroundColor: "transparent",
                           color: "#5f6d8c",
                           boxShadow: "none",
                           padding: "0",
                         }}
                       >
                         <Upload
                           beforeUpload={handleUpload}
                           showUploadList={false}
                           accept=".csv"
                         >
                           <img
                             src={ImportIcon}
                             alt="Import"
                             style={{
                               width: "20px",
                               height: "20px",
                               cursor: "pointer",
                               marginRight: "40px",
                               backgroundColor: "#EBF7ED",
                               borderRadius: "6px",
                             }}
                           />
                         </Upload>
                       </Tooltip>
                     </div>
                     <div className="Custom">
                       <Tooltip
                         title="Sort Column"
                         placement="bottom"
                         visible={visibleSort}
                         onVisibleChange={handleTooltipVisibleChangeSort}
                         overlayInnerStyle={{
                           backgroundColor: "transparent",
                           color: "#5f6d8c",
                           boxShadow: "none",
                           padding: "0",
                         }}
                       >
                         <Popover content={content} trigger="click">
                           <img
                             src={SortIcon}
                             alt="Sort"
                             style={{
                               width: "20px",
                               height: "20px",
                               cursor: "pointer",
                               marginRight: "30px",
                               backgroundColor: "#EBF7ED",
                               borderRadius: "6px",
                             }}
                             onClick={(e) => e.preventDefault()}
                           />
                         </Popover>
                       </Tooltip>
                     </div>
                     <Badge
                       count={filterCount}
                       className="badg"
                       style={{ marginRight: "20px" }}
                     >
                       <Avatar
                         shape="circle"
                         size="small"
                         src={FilterIcon}
                         className="filterstyle"
                         onClick={handleclickme}
                         style={{ marginRight: "20px" }}
                       />
                     </Badge>
 
                     <ButtonOutlined
                       onClick={handleBulkCreateClick}
                       className="bulk_btn"
                     >
                       + Bulk Create
                     </ButtonOutlined>
                     <ButtonOutlined
                       onClick={handleCreateClick}
                       className="Create_btn"
                     >
                       + Create
                     </ButtonOutlined>
                   </div> */}
                </div>
              </Col>
            </Row>
          </WrapperBox>

          <TableStyle>
            <Row gutter={16}>
              <Col xl={24} xs={24}>
                <div className="table_wrapper_one">
                  <div className="consingment_container">
                    <p className="datsource_length">{total} Consignments</p>
                  </div>
                  <div>
                    {window.innerWidth >= 320 && window.innerWidth <= 2561 ? (
                      <>
                        {selectedRowKeys.length > 0 &&
                          activeTab === "label2" && (
                            <div
                              className=""
                              style={{
                                position: "fixed",
                                bottom: "0",
                                zIndex: "20",
                                width: "97%",
                                backgroundColor: "white",
                                maxWidth: "-webkit-fill-available",
                                overflowX: "scroll",
                              }}
                            >
                              <div
                                className="d-flex w-100 align-items-center justify-content-between gap-3 p-2 overflow-x-scroll
                              "
                              >
                                {width < 376 ? (
                                  <div className="d-flex gap-3 align-items-center">
                                    <Deleteunassigned
                                      style={{
                                        cursor: "pointer",
                                        alignSelf: "center",
                                        paddingLeft: "10px",
                                        width: "50px",
                                        height: "50px",
                                      }}
                                      // onClick={() => setIsBulkDeleteModalVisible(true)      }
                                      onClick={() =>
                                        setIsBulkDeleteModalVisible(true)
                                      }
                                    />
                                    <Buttontransparent
                                      className="footer-btn text-danger "
                                      style={{ fontSize: "13px" }}
                                      onClick={() => {
                                        setSelectedRowKeys([]);
                                        setSelectedRows([]);
                                      }}
                                    >
                                      Cancel
                                    </Buttontransparent>
                                    <Tooltip
                                      title={
                                        !assignAllowed ? "No permission" : ""
                                      }
                                    >
                                      <Button
                                        className="footer-btn footer_assigntrip"
                                        style={{
                                          color: "#fff",
                                          fontSize: "13px",
                                        }}
                                        onClick={() => {
                                          if (!assignAllowed) return;
                                          setAssignModal(true);
                                        }}
                                      >
                                        + Add To Trip
                                      </Button>
                                    </Tooltip>
                                    <Tooltip
                                      title={
                                        !assignAllowed ? "No permission" : ""
                                      }
                                    >
                                      <Button
                                        className="footer-btn bg-success"
                                        style={{
                                          color: "#fff",
                                          fontSize: "13px",
                                        }}
                                        onClick={() => {
                                          if (!assignAllowed) return;
                                          if (selectedRows.length > 0) {
                                            const firstRow = selectedRows[0];

                                            tripform.setFieldsValue({
                                              pdate: firstRow.PickUpDateTime
                                                ? dayjs(
                                                    firstRow.PickUpDateTime,
                                                  ).local()
                                                : null,

                                              ddate: firstRow.DropOffDateTime
                                                ? dayjs(
                                                    firstRow.DropOffDateTime,
                                                  ).local()
                                                : null,
                                            });
                                          }

                                          setIsCreateTrip(true);
                                        }}
                                      >
                                        Assign Trip
                                      </Button>
                                    </Tooltip>
                                  </div>
                                ) : (
                                  <>
                                    <div className="container_six">
                                      <Deleteunassigned
                                        style={{
                                          cursor: "pointer",
                                          alignSelf: "center",
                                          paddingLeft: "10px",
                                          width: "50px",
                                          height: "50px",
                                        }}
                                        // onClick={() => setIsBulkDeleteModalVisible(true)      }
                                        onClick={() =>
                                          setIsBulkDeleteModalVisible(true)
                                        }
                                      />
                                      <div className="d-flex gap-3">
                                        <Button
                                          className="footer-btn text-danger "
                                          style={{ fontSize: "13px" }}
                                          onClick={() => {
                                            setSelectedRowKeys([]);
                                            setSelectedRows([]);
                                          }}
                                        >
                                          Cancel
                                        </Button>
                                        <Button
                                          className="footer-btn footer_assigntrip"
                                          style={{
                                            color: "#fff",
                                            fontSize: "13px",
                                          }}
                                          onClick={() => setAssignModal(true)}
                                        >
                                          + Add To Trip
                                        </Button>
                                        <Button
                                          className="footer-btn bg-success"
                                          style={{
                                            color: "#fff",
                                            fontSize: "13px",
                                          }}
                                          onClick={() => {
                                            if (selectedRows.length > 0) {
                                              const firstRow = selectedRows[0];
                                              tripform.setFieldsValue({
                                                pdate: firstRow.PickUpDateTime
                                                  ? dayjs(
                                                      firstRow.PickUpDateTime,
                                                    ).local()
                                                  : null,

                                                ddate: firstRow.DropOffDateTime
                                                  ? dayjs(
                                                      firstRow.DropOffDateTime,
                                                    ).local()
                                                  : null,
                                              });
                                            }

                                            setIsCreateTrip(true);
                                          }}
                                        >
                                          Assign Trip
                                        </Button>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          )}
                      </>
                    ) : (
                      <>
                        {/* {selectedRowKeys.length > 0 && activeTab === "label2" && (
                    

           <div className="" style={{ position: "fixed", bottom: "0" , zIndex:"20", width:"85%", backgroundColor:"white",}}>
 <div className="d-flex w-100 align-items-center justify-content-between gap-3 p-2">
         <Deleteunassigned
                  style={{ cursor: "pointer" ,alignSelf:"center" ,paddingLeft:"10px" , width:"50px", height:"50px"}}
                  // onClick={() => setIsBulkDeleteModalVisible(true)      }
                  onClick={() => setIsBulkDeleteModalVisible(true)}
                />
                <div className="d-flex gap-3">
                  
                  <Button className="footer-btn text-danger"
                        onClick={() => {
                              setSelectedRowKeys([]);
                              setSelectedRows([]);
                            }}
                  >
                    Cancell
                  </Button>
          <Button  className="footer-btn footer_assigntrip" style={{color: "#fff"}} onClick={() => setAssignModal(true)}>
                    + Add To Trip 
                  </Button>
                  <Button  className="footer-btn bg-success" style={{color: "#fff"}}  onClick={() => setIsCreateTrip(true)}>
                    Assign Trip
                  </Button>
                  </div>          
        </div>
        </div>

                    )} */}
                      </>
                    )}
                  </div>
                  <div style={{ marginBottom: "55px" }}>
                    <Spin spinning={loading}>
                      <StyledTable
                        className=""
                        pagination={false}
                        dataSource={assignedConsignments}
                        columns={
                          activeTab === "label2"
                            ? columnsForUnassigned
                            : columnsForAssigned
                        }
                        rowSelection={
                          activeTab === "label2" ? rowSelection : null
                        }
                        rowKey="ConsignId"
                        onRow={(record) => ({
                          onMouseEnter: () => handleClickme(record),
                          onMouseLeave: () => setHoveredrow(null),
                          onClick: () => {
                            handleclick(record);
                          },
                        })}
                      />

                      <ReusablePagination
                        pageSize={pageSize}
                        handlePageSizeChange={handlePageSizeChange}
                        currentPage={currentPage}
                        total={total}
                        handlePageChange={handlePageChange}
                      />
                    </Spin>
                  </div>
                </div>
              </Col>
            </Row>
          </TableStyle>
        </>
      )}
      <ReusableDrawer
        title=""
        open={drawerOpen}
        setOpen={setDrawerOpen}
        onClose={() => setDrawerOpen(false)}
        closable={false}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent
              key="cancel"
              className="cancel-btn"
              onClick={handleCancel}
              style={{
                borderRadius: "26px",
                backgroundColor: "#E8FFEC",
                color: "#2C963D",
                borderColor: "#E8FFEC",
                width: "118px",
                height: "38px",
              }}
            >
              Cancel
            </Buttontransparent>
            <ButtonFilled
              loading={loading}
              key="create"
              type="primary"
              onClick={(e) => form.submit()}
            >
              {isEdit ? "Update" : "Create"}
            </ButtonFilled>
          </div>,
        ]}
      >
        <WrapperBox>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <div className="Creating_Consignment">
                <p>
                  {isEdit
                    ? "Modifying Consignment"
                    : formType === "addEdit"
                      ? "Creating a Single Consingment"
                      : "Creating Bulk Consignment"}
                </p>

                <span>
                  <CloseOutlined onClick={handleCancel} />
                </span>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              {isEdit ? (
                <GridBuilder
                  formStructureJson={BulkCreateForm}
                  handleChange={handleChange}
                  formSubmit={handleSubmitForm}
                  initialValues={formData}
                  form={form}
                  locationClick={locationClick}
                  handleSelectChange={handleSelectChange}
                />
              ) : (
                // Create mode: show form based on formType
                <>
                  {formType === "addEdit" && (
                    <GridBuilder
                      formStructureJson={BulkCreateForm}
                      handleChange={handleChange}
                      formSubmit={handleSubmitForm}
                      initialValues={formData}
                      form={form}
                      locationClick={locationClick}
                      handleSelectChange={handleSelectChange}
                    />
                  )}
                  {formType === "bulkCreate" && (
                    <GridBuilder
                      formStructureJson={AddEditFormm}
                      handleChange={handleChange}
                      formSubmit={bulkSubmit}
                      initialValues={formData}
                      form={form}
                      locationClick={locationClick}
                      handleSelectChange={handleSelectChange}
                    />
                  )}
                </>
              )}
            </Col>
          </Row>
        </WrapperBox>
      </ReusableDrawer>
      <UIModal
        header="Assign Trip"
        open={assignModal}
        onClose={() => {
          setAssignModal(false);
          setAssignVehicleId(null);
        }}
        footer={[
          <div
            key="footer"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent
              onClick={() => {
                setAssignModal(false);
                setAssignVehicleId(null);
              }}
            >
              Cancel
            </Buttontransparent>
            <ButtonFilled
              loading={loading}
              onClick={() => AssignedVehicle(assignVehicleId)}
            >
              Update
            </ButtonFilled>
          </div>,
        ]}
        size="550px"
        closeButton={false}
      >
        <div className="p-3">
          <Select
            placeholder="Select Vehicle"
            value={formData.office}
            onChange={(value) => setAssignVehicleId(value)}
            style={{ width: "100%" }}
            validationRules={[
              { required: true, message: "Office is required" },
            ]}
          >
            {driverWithVehicle?.map((option) => (
              <Select.Option key={option} value={option?.VEHID}>
                {`${option.REGNO}-${option?.DriverName}`}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div className="p-3">
          <Select
            placeholder="Select Trip Code"
            onChange={onTripCodeSelect}
            value={selectedTripCode}
            style={{ width: "100%" }}
          >
            {Array.isArray(codeList) &&
              codeList.map((item) => (
                <Select.Option key={item.TripId} value={item.Code}>
                  {item.Code}
                </Select.Option>
              ))}
          </Select>
        </div>
      </UIModal>
      <UIModal
        width={600}
        height={600}
        open={isconfigModalVisible}
        onClose={() => {
          setIsconfigModalVisible(false);
        }}
        closeButton={false}
        size="md"
        header={
          <div className="text-start">
            <h2>Customized Column</h2>
            <label
              style={{ marginBottom: 8, display: "block", color: "#5F6D8C" }}
            >
              Columns
            </label>
          </div>
        }
        footer={
          <div className="mt-2 w-100 d-flex justify-content-end">
            <ButtonFilled
              onClick={() => {
                setIsconfigModalVisible(false); // Close the modal
              }}
            >
              Save
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsconfigModalVisible(false); // Just close the modal
              }}
            >
              Cancel
            </Buttontransparent>
          </div>
        }
      >
        <Select
          mode="multiple"
          style={{ width: "100%" }}
          placeholder="Select custom columns"
          value={selectedCustomColumns}
          onChange={setSelectedCustomColumns}
          dropdownStyle={{ maxHeight: 250, overflow: "auto" }}
          dropdownRender={(menu) => (
            <div>
              <Checkbox.Group
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "8px 12px",
                }}
                value={selectedCustomColumns}
                onChange={setSelectedCustomColumns}
              >
                {customFieldOptions.map((option) => (
                  <Checkbox
                    key={option.value}
                    value={option.value}
                    disabled={option.disabled}
                  >
                    {option.label}
                  </Checkbox>
                ))}
              </Checkbox.Group>
            </div>
          )}
        >
          {customFieldOptions.map((option) => (
            <Select.Option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </Select.Option>
          ))}
        </Select>
      </UIModal>
      <ReusableDrawer
        title=""
        open={isCreateTrip}
        setOpen={() => setIsCreateTrip(true)}
        onClose={() => setIsCreateTrip(false)}
        closable={false}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent
              key="cancel"
              className="cancel-btn"
              onClick={() => {
                tripform.resetFields();
                setIsCreateTrip(false);
                // setModaldrawer(false);
              }}
              style={{
                borderRadius: "26px",
                backgroundColor: "#E8FFEC",
                color: "#2C963D",
                borderColor: "#E8FFEC",
                width: "118px",
                height: "38px",
              }}
            >
              Cancel
            </Buttontransparent>
            <Spin spinning={loading}>
              <ButtonFilled
                loading={loading}
                key="create"
                type="primary"
                onClick={(e) => tripform.submit()}
              >
                Create
              </ButtonFilled>
            </Spin>
          </div>,
        ]}
      >
        <WrapperBox>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h3 style={{ margin: 0 }}>Creating a Trip</h3>
            <CloseOutlined
              onClick={() => {
                tripform.resetFields();
                setIsCreateTrip(false);
              }}
              style={{ fontSize: 20, cursor: "pointer" }}
            />
          </div>
          <hr style={{ margin: "12px 0" }} />
          <Collapse
            style={{ backgroundColor: "#EBF7ED" }}
            expandIconPosition="end"
          >
            <Panel
              header={
                <span style={{ color: "#2C963D" }}>Consignment Info</span>
              }
              key="1"
            >
              <StyledTable
                className="trip-table"
                pagination={false}
                dataSource={selectedRows}
                columns={selectedColumns}
                rowKey="ConsignId"
                style={{ backgroundColor: "#EBF7ED" }}
              />
            </Panel>
          </Collapse>
          <Form
            form={tripform}
            layout="vertical"
            className="mt-3"
            onFinish={handleTripCreate}
            initialValues={{
              shipmentType:
                userInfo?.MCID === 55 || userInfo?.MCID === 78 ? 1 : "",
              tripType: userInfo?.MCID === 55 || userInfo?.MCID === 78 ? 1 : "",
              finishtype:
                userInfo?.MCID === 71 ||
                userInfo?.MCID === 46 ||
                userInfo?.MCID === 55
                  ? 5
                  : userInfo?.MCID === 78
                    ? 1
                    : userInfo?.MCID === 72
                      ? 0
                      : "",
              dispatchtype:
                userInfo?.MCID === 46 ||
                userInfo?.MCID === 55 ||
                userInfo?.MCID === 3 ||
                userInfo?.MCID === 78 ||
                userInfo?.MCID === 72
                  ? "0"
                  : "",
            }}
          >
            <Row gutter={16}>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Company"
                  name="company"
                  rules={[{ required: true, message: "Please select Company" }]}
                  initialValue={
                    Number(userInfo?.MCID) === 59
                      ? formData?.company
                      : formData?.company || userInfo?.ECTSCompId || ""
                  } // pre-fill with user's company
                >
                  <Select
                    className="w-100"
                    allowClear={false}
                    showSearch
                    loading={loading}
                    disabled={Number(userInfo?.MCID) !== 59}
                    options={companyOptions}
                    onChange={handleCompanyChange}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Trip Type"
                  name="tripType"
                  rules={[
                    { required: true, message: "Please select Trip Type" },
                  ]}
                >
                  <Select className="w-100" showSearch allowClear>
                    {tripType.map((type) => (
                      <Option key={type.value} value={type.value}>
                        {type.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Dispatch Type"
                  name="dispatchtype"
                  rules={[
                    { required: true, message: "Please select Dispatch Type" },
                  ]}
                >
                  <Select
                    className="w-100"
                    showSearch
                    disabled={userInfo?.MCID === 3}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {DispatchType.map((type) => (
                      <Option key={type.value} value={type.value}>
                        {type.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Shipment Type"
                  name="shipmentType"
                  rules={[
                    { required: true, message: "Please select Shipment Type" },
                  ]}
                  initialValue={
                    userInfo?.MCID === 71 ||
                    userInfo?.MCID === 46 ||
                    userInfo?.MCID === 78
                      ? 1
                      : undefined
                  }
                >
                  <Select
                    className="w-100"
                    showSearch
                    allowClear={userInfo?.MCID !== 71}
                    disabled={userInfo?.MCID === 71} // disable for MCID 71
                  >
                    {(userInfo?.MCID === 71
                      ? shipmentType.filter((type) => type.value === 1)
                      : shipmentType
                    ).map((type) => (
                      <Option key={type.value} value={type.value}>
                        {type.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Finished Type"
                  name="finishtype"
                  rules={[
                    { required: true, message: "Please select Finish Type" },
                  ]}
                >
                  <Select
                    className="w-100"
                    showSearch
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    disabled={userInfo?.MCID === 71}
                  >
                    {(userInfo?.MCID === 71
                      ? FinishType.filter((type) => type.value === 5) // only show 5
                      : FinishType
                    ).map((type) => {
                      return (
                        <Option key={type.value} value={type.value}>
                          {type.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Pickup Date & Time"
                  name="pdate"
                  rules={[
                    { required: true, message: "Pickup date is required" },
                  ]}
                >
                  <DatePicker
                    showTime
                    format="DD-MM-YYYY HH:mm"
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Dropoff Date & Time"
                  name="ddate"
                  rules={[
                    { required: true, message: "Dropoff date is required" },
                  ]}
                >
                  <DatePicker
                    showTime
                    format="DD-MM-YYYY HH:mm"
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                {/*
                 */}
                <Form.Item
                  label="Vehicle"
                  name="vehicle"
                  rules={[
                    { required: true, message: "Please select a vehicle" },
                  ]}
                >
                  <Select
                    className="w-100"
                    showSearch
                    allowClear
                    options={vehicleOptions} // should match `vehicleList` structure
                    onChange={handleVehicleChange}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Device"
                  name="device"
                  rules={[{ required: true, message: "Please select Device" }]}
                >
                  <Select
                    className="w-100"
                    showSearch
                    disabled={isDeviceDisabled}
                    allowClear
                    options={deviceOptions}
                    // onChange={handleDeviceChange}
                    loading={loading}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  ></Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Driver"
                  name="driver"
                  rules={[{ required: true, message: "Please select Driver" }]}
                >
                  <Select
                    className="w-100"
                    showSearch
                    // disabled={isDriverDisabled}
                    allowClear
                    // onChange={handleDriverChange}
                    loading={loading}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {" "}
                    {driverList?.map((option) => (
                      <Select.Option key={option} value={option?.FULLNM}>
                        {`${option.FULLNM}`}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Delivery Note Number"
                  name="deliveryNo"
                  rules={[
                    { required: true, message: "Delivery no is required" },
                  ]}
                >
                  <Input placeholder="Enter text here" />
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Route"
                  name="route"
                  rules={[{ required: true, message: "Route is required" }]}
                >
                  <Select
                    className="w-100"
                    showSearch
                    allowClear
                    options={routeOptions}
                    loading={loading}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  ></Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item label="Trip Allowance" name="tripallowance">
                  <Input
                    type="number"
                    style={{ width: "100%" }}
                    defaultValue={0}
                    min={0}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                {/* Fuel Quantity */}
                <Form.Item label="Fuel Quantity" name="fuelQuantity">
                  <Input type="number" placeholder="" />
                </Form.Item>
              </Col>

              <Col xs={24} md={24}>
                <Form.Item label="Remark" name="remark">
                  <Input.TextArea placeholder="" rows={4} />
                </Form.Item>
              </Col>

              {tripCustomFields.map((field) => (
                <Col xs={24} md={6} key={field.CFID}>
                  <Form.Item
                    label={field.FIELDNAME}
                    name={field.FIELDNAME.replace(/\s+/g, "_").toLowerCase()}
                    rules={
                      field.REQUIRED
                        ? [
                            {
                              required: true,
                              message: `${field.FIELDNAME} is required`,
                            },
                          ]
                        : []
                    }
                  >
                    <Input />
                  </Form.Item>
                </Col>
              ))}
            </Row>
          </Form>
        </WrapperBox>
      </ReusableDrawer>
      <UIModal
        width={500}
        open={isBulkDeleteModalVisible}
        onClose={() => setIsBulkDeleteModalVisible(false)} // Close the modal
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <GeoDelete />
          <h4>Delete Consignments?</h4>
          <p>
            This action will permanently delete the selected consignments.
            <br />
            Do you want to proceed?
          </p>{" "}
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              onClick={handleBulkDelete} // Call the delete function
              loading={loading}
            >
              Confirm
            </ButtonFilled>
            <Buttontransparent
              onClick={() => setIsBulkDeleteModalVisible(false)} // Close the modal
            >
              Cancel
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <LocationPicker
        visible={locationModal}
        onClose={() => setLocationModal(false)}
        onSelect={handleLocationSelect}
      />
      <ImportFileModal
        open={importOpen}
        onClose={() => setImportOpen(false)}
        handleUpload={handleUpload}
        handleDownloadCSVTemplate={handleDownloadCSVTemplate}
      />
    </>
  );
};

export default ConsignmentAI;

// Place this at the top of your file
const reverseGeocode = async (lat, lng) => {
  if (!lat || !lng) return "-";
  try {
    const response = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${MAPBOX_TOKEN}`,
    );
    const data = await response.json();
    return data.features[0].place_name || "-";
  } catch (error) {
    return "-";
  }
};
// Place this at the top of your file or in a separate file
const LocationCell = ({
  startLat,
  startLng,
  endLat,
  endLng,
  locationCache,
  setLocationCache,
  renderText,
}) => {
  const [startAddress, setStartAddress] = useState(
    locationCache[`${startLat},${startLng}`],
  );
  const [endAddress, setEndAddress] = useState(
    locationCache[`${endLat},${endLng}`],
  );

  useEffect(() => {
    const startKey = `${startLat},${startLng}`;
    const endKey = `${endLat},${endLng}`;

    if (startLat && startLng && !locationCache[startKey]) {
      reverseGeocode(startLat, startLng).then((address) => {
        setLocationCache((prev) => ({ ...prev, [startKey]: address }));
        setStartAddress(address);
      });
    }

    if (endLat && endLng && !locationCache[endKey]) {
      reverseGeocode(endLat, endLng).then((address) => {
        setLocationCache((prev) => ({ ...prev, [endKey]: address }));
        setEndAddress(address);
      });
    }
    // eslint-disable-next-line
  }, [startLat, startLng, endLat, endLng]);

  const start = startAddress || locationCache[`${startLat},${startLng}`] || "-";
  const end = endAddress || locationCache[`${endLat},${endLng}`] || "-";

  const locationText = `${end}`;

  // apply your reusable render logic
  if (renderText) {
    return renderText(locationText);
  }

  return <span>{locationText}</span>;
};
